import react from 'react'
import { userStore, UserState } from '../api/AuthService';
import { DriverProfile } from '../api/model/DriverProfile';

export const HaulingAgreementFlatbed = (props: {ownerData?: any, unitData?: any, tierTable?: any, viewObject?: any, signatureData?: any, date?: any, year?: any, escrow?: any}) => {

  const {userInfo}: { userInfo: DriverProfile } = userStore((state: UserState) => ({userInfo: state.driver}));

    return <div style={{width: "50%"}}>
    <title>Hauling Agreement 2024 FLATBED</title>
    <style
      type="text/css"
      dangerouslySetInnerHTML={{
        __html:
          ' * {margin:0; padding:0; text-indent:0; }\n .s1 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: bold; text-decoration: underline; font-size: 20pt; }\n h1 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 20pt; }\n h2 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 14pt; }\n .s2 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 14pt; }\n .s4 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n a { color: #00F; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: underline; font-size: 10pt; }\n h3 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 10pt; }\n .p, p { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; margin:0pt; }\n .s7 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: underline; font-size: 10pt; }\n .s8 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: underline; font-size: 10pt; }\n .s9 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: underline; font-size: 10pt; vertical-align: 1pt; }\n .s11 { color: black; font-family:Arial, sans-serif; font-style: italic; font-weight: normal; text-decoration: none; font-size: 10pt; }\n .s12 { color: black; font-family:Arial, sans-serif; font-style: italic; font-weight: bold; text-decoration: none; font-size: 10pt; }\n .s13 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; vertical-align: 21pt; }\n .s14 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; vertical-align: -2pt; }\n .s15 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: underline; font-size: 12pt; }\n .s16 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 12pt; }\n .s17 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 1pt; }\n h4 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 9.5pt; }\n .s19 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 9.5pt; }\n .s20 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 6pt; vertical-align: 3pt; }\n .s22 { color: black; font-family:"Times New Roman", serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 6.5pt; vertical-align: 3pt; }\n .s23 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n .s24 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; vertical-align: 1pt; }\n .s27 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; vertical-align: -1pt; }\n .s28 { color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 6.5pt; vertical-align: 3pt; }\n li {display: block; }\n #l1 {padding-left: 0pt;counter-reset: c1 1; }\n #l1> li>*:first-child:before {counter-increment: c1; content: counter(c1, decimal)". "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l1> li:first-child>*:first-child:before {counter-increment: c1 0;  }\n #l2 {padding-left: 0pt;counter-reset: c2 2; }\n #l2> li>*:first-child:before {counter-increment: c2; content: "("counter(c2, lower-latin)") "; color: black; font-style: normal; font-weight: normal; text-decoration: none; }\n #l2> li:first-child>*:first-child:before {counter-increment: c2 0;  }\n #l3 {padding-left: 0pt;counter-reset: c2 2; }\n #l3> li>*:first-child:before {counter-increment: c2; content: "("counter(c2, lower-latin)") "; color: black; font-style: normal; font-weight: normal; text-decoration: none; }\n #l3> li:first-child>*:first-child:before {counter-increment: c2 0;  }\n #l4 {padding-left: 0pt;counter-reset: d1 1; }\n #l4> li>*:first-child:before {counter-increment: d1; content: counter(d1, upper-latin)". "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l4> li:first-child>*:first-child:before {counter-increment: d1 0;  }\n #l5 {padding-left: 0pt;counter-reset: d2 1; }\n #l5> li>*:first-child:before {counter-increment: d2; content: counter(d2, lower-roman)". "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l5> li:first-child>*:first-child:before {counter-increment: d2 0;  }\n #l6 {padding-left: 0pt;counter-reset: d2 1; }\n #l6> li>*:first-child:before {counter-increment: d2; content: counter(d2, lower-roman)". "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l6> li:first-child>*:first-child:before {counter-increment: d2 0;  }\n #l7 {padding-left: 0pt;counter-reset: e1 1; }\n #l7> li>*:first-child:before {counter-increment: e1; content: counter(e1, upper-latin)". "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l7> li:first-child>*:first-child:before {counter-increment: e1 0;  }\n #l8 {padding-left: 0pt;counter-reset: c2 2; }\n #l8> li>*:first-child:before {counter-increment: c2; content: "("counter(c2, lower-latin)") "; color: black; font-style: normal; font-weight: normal; text-decoration: none; }\n #l8> li:first-child>*:first-child:before {counter-increment: c2 0;  }\n #l9 {padding-left: 0pt;counter-reset: f1 1; }\n #l9> li>*:first-child:before {counter-increment: f1; content: counter(f1, lower-roman)". "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l9> li:first-child>*:first-child:before {counter-increment: f1 0;  }\n #l10 {padding-left: 0pt;counter-reset: c2 2; }\n #l10> li>*:first-child:before {counter-increment: c2; content: "("counter(c2, lower-latin)") "; color: black; font-style: normal; font-weight: normal; text-decoration: none; }\n #l10> li:first-child>*:first-child:before {counter-increment: c2 0;  }\n #l11 {padding-left: 0pt;counter-reset: c2 2; }\n #l11> li>*:first-child:before {counter-increment: c2; content: "("counter(c2, lower-latin)") "; color: black; font-style: normal; font-weight: normal; text-decoration: none; }\n #l11> li:first-child>*:first-child:before {counter-increment: c2 0;  }\n #l12 {padding-left: 0pt;counter-reset: g1 1; }\n #l12> li>*:first-child:before {counter-increment: g1; content: counter(g1, lower-roman)". "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l12> li:first-child>*:first-child:before {counter-increment: g1 0;  }\n #l13 {padding-left: 0pt;counter-reset: h1 2; }\n #l13> li>*:first-child:before {counter-increment: h1; content: "("counter(h1, lower-latin)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l13> li:first-child>*:first-child:before {counter-increment: h1 0;  }\n #l14 {padding-left: 0pt;counter-reset: h2 1; }\n #l14> li>*:first-child:before {counter-increment: h2; content: counter(h2, lower-roman)". "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l14> li:first-child>*:first-child:before {counter-increment: h2 0;  }\n #l15 {padding-left: 0pt;counter-reset: h3 1; }\n #l15> li>*:first-child:before {counter-increment: h3; content: "("counter(h3, upper-latin)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l15> li:first-child>*:first-child:before {counter-increment: h3 0;  }\n #l16 {padding-left: 0pt;counter-reset: c2 2; }\n #l16> li>*:first-child:before {counter-increment: c2; content: "("counter(c2, lower-latin)") "; color: black; font-style: normal; font-weight: normal; text-decoration: none; }\n #l16> li:first-child>*:first-child:before {counter-increment: c2 0;  }\n #l17 {padding-left: 0pt;counter-reset: c2 2; }\n #l17> li>*:first-child:before {counter-increment: c2; content: "("counter(c2, lower-latin)") "; color: black; font-style: normal; font-weight: normal; text-decoration: none; }\n #l17> li:first-child>*:first-child:before {counter-increment: c2 0;  }\n #l18 {padding-left: 0pt;counter-reset: i1 1; }\n #l18> li>*:first-child:before {counter-increment: i1; content: counter(i1, upper-latin)". "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l18> li:first-child>*:first-child:before {counter-increment: i1 0;  }\n li {display: block; }\n #l19 {padding-left: 0pt;counter-reset: j1 1; }\n #l19> li>*:first-child:before {counter-increment: j1; content: counter(j1, decimal)". "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 9.5pt; }\n #l19> li:first-child>*:first-child:before {counter-increment: j1 0;  }\n #l20 {padding-left: 0pt;counter-reset: j2 1; }\n #l20> li>*:first-child:before {counter-increment: j2; content: counter(j2, upper-latin)". "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l20> li:first-child>*:first-child:before {counter-increment: j2 0;  }\n li {display: block; }\n #l21 {padding-left: 0pt;counter-reset: k1 1; }\n #l21> li>*:first-child:before {counter-increment: k1; content: counter(k1, decimal)". "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l21> li:first-child>*:first-child:before {counter-increment: k1 0;  }\n #l22 {padding-left: 0pt;counter-reset: k2 2; }\n #l22> li>*:first-child:before {counter-increment: k2; content: "("counter(k2, lower-latin)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l22> li:first-child>*:first-child:before {counter-increment: k2 0;  }\n #l23 {padding-left: 0pt;counter-reset: k2 2; }\n #l23> li>*:first-child:before {counter-increment: k2; content: "("counter(k2, lower-latin)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l23> li:first-child>*:first-child:before {counter-increment: k2 0;  }\n #l24 {padding-left: 0pt;counter-reset: l1 1; }\n #l24> li>*:first-child:before {counter-increment: l1; content: counter(l1, upper-latin)". "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l24> li:first-child>*:first-child:before {counter-increment: l1 0;  }\n #l25 {padding-left: 0pt;counter-reset: l2 1; }\n #l25> li>*:first-child:before {counter-increment: l2; content: counter(l2, upper-roman)". "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l25> li:first-child>*:first-child:before {counter-increment: l2 0;  }\n #l26 {padding-left: 0pt;counter-reset: l3 1; }\n #l26> li>*:first-child:before {counter-increment: l3; content: counter(l3, lower-latin)") "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l26> li:first-child>*:first-child:before {counter-increment: l3 0;  }\n #l27 {padding-left: 0pt;counter-reset: m1 1; }\n #l27> li>*:first-child:before {counter-increment: m1; content: counter(m1, upper-roman)". "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l27> li:first-child>*:first-child:before {counter-increment: m1 0;  }\n #l28 {padding-left: 0pt;counter-reset: l2 1; }\n #l28> li>*:first-child:before {counter-increment: l2; content: counter(l2, upper-roman)". "; color: black; font-family:Arial, sans-serif; font-style: normal; font-weight: normal; text-decoration: none; font-size: 10pt; }\n #l28> li:first-child>*:first-child:before {counter-increment: l2 0;  }\n table, tbody {vertical-align: top; overflow: visible; }\n'
      }}
    />
    <p
      className="s1"
      style={{
        paddingTop: "3pt",
        paddingLeft: "11pt",
        textIndent: "0pt",
        textAlign: "center"
      }}
    >
      CONTRACTOR HAULING AGREEMENT
    </p>
    <h1
    style={{
      paddingTop: "22pt",
      paddingLeft: "0pt",
      textIndent: "0pt",
      textAlign: "center"
    }}
  >
    Western Express, Inc. &amp; [{props.viewObject !== undefined ? props.viewObject.OwnerName1 : props.ownerData.name}]
  </h1>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
    <h2 style={{ paddingLeft: "11pt", textIndent: "0pt", textAlign: "center" }}>
      Congratulations on taking your first step towards owning your own business!
    </h2>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <h2 style={{ paddingLeft: "11pt", textIndent: "0pt", textAlign: "center" }}>
      Now comes the hard part…
    </h2>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p
      className="s2"
      style={{ paddingLeft: "23pt", textIndent: "0pt", textAlign: "justify" }}
    >
      You are a vital part of the economic prosperity of this country. As stated
      by the Small Business &amp; Entrepreneurship Council, “America’s economy is
      a small business economy”.
    </p>
    <p
      className="s2"
      style={{
        paddingTop: "16pt",
        paddingLeft: "23pt",
        textIndent: "0pt",
        textAlign: "justify"
      }}
    >
      In 2021, over 16 million people in the United States were self-employed and
      small businesses with less than 10 employees made up over 78% of United
      States employers. In the transportation and warehousing industry, about 86%
      of businesses are operated as self-employed businesses.
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p
      className="s2"
      style={{ paddingLeft: "23pt", textIndent: "0pt", textAlign: "justify" }}
    >
      However, owning and operating your own business is <u>hard work</u>. As you
      consider and take your next steps,{" "}
      <u>YOU MUST KEEP IN MIND THAT MANY SMALL</u>{" "}
      <u>BUSINESSES DO NOT SUCCEED</u>.
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p
      className="s2"
      style={{ paddingLeft: "23pt", textIndent: "0pt", textAlign: "justify" }}
    >
      From 1994-2019, an average of 67.6% of new employer establishments survived
      at least two years. During the same period, the five-year survival rate was
      48.9%, the ten-year survival rate was 33.6%, and the fifteen-year survival
      rate was 25.7%. Over 75% of all businesses have gross revenues of less than
      $100,000 per year.
    </p>
    <p
      className="s2"
      style={{
        paddingTop: "16pt",
        paddingLeft: "23pt",
        textIndent: "0pt",
        textAlign: "justify"
      }}
    >
      Your business has the potential to succeed, but it will require hard work,
      sacrifice, and patience. Good luck on your journey!
    </p>
    <p
      className="s4"
      style={{
        paddingTop: "11pt",
        paddingLeft: "23pt",
        textIndent: "0pt",
        textAlign: "left"
      }}
    >
      SOURCES:
    </p>
    <p style={{ paddingLeft: "23pt", textIndent: "0pt", textAlign: "left" }}>
      <span
        style={{
          color: "#00F",
          fontFamily: '"Times New Roman", serif',
          fontStyle: "normal",
          fontWeight: "normal",
          textDecoration: "underline",
          fontSize: "10pt"
        }}
      >
        https://sbecouncil.org/about-us/facts-and-
      </span>
      <a
        href="https://sbecouncil.org/about-us/facts-and-data/#%3A%7E%3Atext%3D%E2%80%9CFrom%201994%2D2019%2C%20an%2Csurvival%20rate%20was%2025.7%25.%E2%80%9D"
        style={{
          color: "#00F",
          fontFamily: '"Times New Roman", serif',
          fontStyle: "normal",
          fontWeight: "normal",
          textDecoration: "none",
          fontSize: "10pt"
        }}
        target="_blank"
      >
        {" "}
      </a>
      <span
        style={{
          color: "#00F",
          fontFamily: '"Times New Roman", serif',
          fontStyle: "normal",
          fontWeight: "normal",
          textDecoration: "underline",
          fontSize: "10pt"
        }}
      >
        data/#:~:text=%E2%80%9CFrom%201994%2D2019%2C%20an,survival%20rate%20was%2025.7%25.%E2%80%
      </span>
      <a
        href="https://sbecouncil.org/about-us/facts-and-data/#%3A%7E%3Atext%3D%E2%80%9CFrom%201994%2D2019%2C%20an%2Csurvival%20rate%20was%2025.7%25.%E2%80%9D"
        style={{
          color: "#00F",
          fontFamily: '"Times New Roman", serif',
          fontStyle: "normal",
          fontWeight: "normal",
          textDecoration: "none",
          fontSize: "10pt"
        }}
        target="_blank"
      >
        {" "}
      </a>
      <a
        href="https://sbecouncil.org/about-us/facts-and-data/#%3A%7E%3Atext%3D%E2%80%9CFrom%201994%2D2019%2C%20an%2Csurvival%20rate%20was%2025.7%25.%E2%80%9D"
        target="_blank"
      >
        9D
      </a>
    </p>
    <p
      style={{
        paddingTop: "11pt",
        paddingLeft: "23pt",
        textIndent: "0pt",
        textAlign: "left"
      }}
    >
      <a href="https://www.census.gov/data/tables/2019/econ/susb/2019-susb-annual.html">
        https://www.census.gov/data/tables/2019/econ/susb/2019-susb-annual.html
      </a>
    </p>
    <h3
      style={{
        paddingTop: "4pt",
        paddingLeft: "11pt",
        textIndent: "0pt",
        textAlign: "center"
      }}
    >
      CONTRACTOR HAULING AGREEMENT
    </h3>
    <p
      style={{
        paddingTop: "11pt",
        paddingLeft: "23pt",
        textIndent: "0pt",
        textAlign: "justify"
      }}
    >
      THIS AGREEMENT (“Contract”) is made and effective this{" "}
      <u>{props.viewObject !== undefined ? props.viewObject.date1 : props.date}</u> day of{" "}
      <u>
        {props.viewObject !== undefined ? props.viewObject.Year3 : props.year}
      </u>
    </p>
    <p style={{ paddingLeft: "23pt", textIndent: "0pt", textAlign: "justify" }}>
      <span className="s7">
        {" "}
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
      </span>
      , between Western Express, Inc., a Tennessee corporation (“CARRIER”), having
      its principle offices at 7135 Centennial Place, Nashville, TN 37209 and{" "}
      <u>
        {props.viewObject !== undefined ? props.viewObject.OwnerName1 : props.ownerData.name }&nbsp;
      </u>
      (“CONTRACTOR”), having its principle offices at{" "}
      <u>
      {props.viewObject !== undefined ? props.viewObject.OwnerAddress1 : props.ownerData!.address + " " + props.ownerData!.city + " " + props.ownerData!.state}
      </u>
      .
    </p>
    <p style={{ paddingTop: "11pt", textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p style={{ paddingLeft: "23pt", textIndent: "35pt", textAlign: "left" }}>
      WHEREAS, CARRIER, an Interstate For Hire Contract Motor Carrier, wishes to
      obtain transportation with equipment that it does not own through this
      Contract with CONTRACTOR; and
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p style={{ paddingLeft: "23pt", textIndent: "35pt", textAlign: "left" }}>
      WHEREAS, CONTRACTOR is the owner or lessee of equipment which CONTRACTOR
      represents is suitable to perform the contracted for services under this
      Contract; and
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p style={{ paddingLeft: "23pt", textIndent: "35pt", textAlign: "left" }}>
      WHEREAS, CONTRACTOR is engaged in the independent business of transporting
      freight by motor vehicle on behalf of private or common carriers, shippers,
      consignees, brokers and others; and,
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p style={{ paddingLeft: "23pt", textIndent: "35pt", textAlign: "left" }}>
      NOW, THEREFORE, in consideration of the mutual covenants and agreements
      contained herein, the parties mutually agree as follows:
    </p>
    <ol id="l1">
      <li data-list-text={1}>
        <h3
          style={{
            paddingTop: "11pt",
            paddingLeft: "23pt",
            textIndent: "35pt",
            textAlign: "justify"
          }}
        >
          <u>Leased Equipment</u>.{" "}
          <span className="p">
            CONTRACTOR agrees to furnish the Equipment described in Appendix 1 for
            freight hauling on behalf of CARRIER and CARRIER shall furnish
            CONTRACTOR with the signed receipt attached hereto as Appendix 2 when
            the Equipment is transferred to CARRIER, which identifies the
            Equipment and the time and date of Equipment transfer. Appendix 1 and
            2 are incorporated into this Contract by this reference. CARRIER
            agrees to make commodities and freight available from time to time for
            transportation by CONTRACTOR under the terms of this Contract,
            although this shall not be construed as an agreement or commitment by
            CARRIER to furnish any specific number of loads or pounds of freight
            for transportation by CONTRACTOR during any particular time period, at
            any particular time or at any particular place or location. CONTRACTOR
            will provide all labor which is necessary to operate the Equipment, to
            load, secure and unload commodities and freight which are transported
            and CONTRACTOR shall have sole and exclusive control over that labor,
            as provided in this Contract. If the shipper or consignee does not
            assume loading, securement or unloading responsibilities, CONTRACTOR
            shall be responsible for such loading, securement or unloading of
            freight transported on behalf of CARRIER at CONTRACTOR's sole expense.
          </span>
        </h3>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={2}>
        <h3
          style={{
            paddingLeft: "23pt",
            textIndent: "35pt",
            textAlign: "justify"
          }}
        >
          <u>Payments&nbsp; to&nbsp; CONTRACTOR</u>.{" "}
          <span className="p">
            For the performance of each load hauled by CONTRACTOR in accordance
            with the terms of this Contract, CARRIER agrees to pay the amount
            negotiated and agreed to between CARRIER and CONTRACTOR as set forth
            in the attached Appendix 3. Unless otherwise specified in Appendix 3,
            the current version of Rand McNally TM Inc. Milemaker will be used to
            compute mileage. CONTRACTOR hereby authorizes CARRIER to make the
            deductions set forth and specified in the attached Appendix 4, and
            those deductions identified and referenced elsewhere in this Contract,
            from CONTRACTOR’s settlements/compensation (“settlements”) and/or the
            Escrow Fund maintained by CONTRACTOR pursuant to Paragraph 14 below.
            Appendix 3 and 4 are incorporated into this Contract by this
            reference.
          </span>
        </h3>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={3}>
        <h3
          style={{
            paddingLeft: "23pt",
            textIndent: "35pt",
            textAlign: "justify"
          }}
        >
          <u>Intent of Parties</u>.{" "}
          <span className="p">
            This Contract is intended by the parties to create the relationship of
            INDEPENDENT CONTRACTOR between CONTRACTOR and CARRIER and not the
            relationship of employer/employee, lessor/lessee, master/servant,
            partners or joint venture. Neither CONTRACTOR, nor CONTRACTOR’s
            employees, agents, servants, contractors, subcontractors, helpers or
            drivers (collectively “Workers”) are to be considered employees of
            CARRIER at any time, under any circumstance, or for any purpose. It is
            agreed by the parties hereto that CONTRACTOR assumes full and complete
            responsibility for all Workers utilized by CONTRACTOR in the
            performance of all duties and obligations under this Contract.{" "}
          </span>
          CONTRACTOR specifically acknowledges and agrees that no representations
          or promises have been made to CONTRACTOR that he or she will make any
          specific amount of income, revenue, profit, compensation or monies
          (collectively “Revenue”) related to this Contract or the services
          CONTRACTOR performs hereunder and that CARRIER has not and does not
          guarantee or promise
        </h3>
        <h3
          style={{
            paddingTop: "4pt",
            paddingLeft: "23pt",
            textIndent: "0pt",
            textAlign: "left"
          }}
        >
          that CONTRACTOR will make any specific amount of Revenue in relation to
          this Contract or the services performed by CONTRACTOR hereunder.
        </h3>
      </li>
      <li data-list-text={4}>
        <h3
          style={{
            paddingTop: "11pt",
            paddingLeft: "23pt",
            textIndent: "35pt",
            textAlign: "justify"
          }}
        >
          <u>Settlements</u>.{" "}
          <span className="p">
            (a) CARRIER shall settle with and pay CONTRACTOR within fifteen (15)
            days of the submission by CONTRACTOR to CARRIER of the necessary
            delivery documents concerning the trip in the service of CARRIER,
            driver logs as required by the U.S. Department of Transportation
            ("DOT"), and those documents necessary for CARRIER to secure payment
            from the shipper and/or consignee, such as the bill of lading or
            freight bill, signed and dated confirming that the authorized
            consignee received the freight. Subject to the foregoing, and except
            as set forth in Section 19 (Unscheduled Payments) below, CARRIER has
            not set any time limits for the submission by CONTRACTOR of the
            required delivery documents. Payment to CONTRACTOR shall not be made
            contingent upon submission of a bill of lading to which no exceptions
            have been taken. In the event a dispute as to any settlement arises,
            CONTRACTOR acknowledges and agrees that if CONTRACTOR does not object
            in writing to a specific settlement within thirty (30) days from the
            date CARRIER issues such settlement, such settlement shall be final,
            and CONTRACTOR shall not make any claim or bring any claim or action
            against CARRIER relating to the payments and/or deductions reflected
            in the settlement.
          </span>
        </h3>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <ol id="l2">
          <li data-list-text="(b)">
            <p
              style={{
                paddingLeft: "23pt",
                textIndent: "71pt",
                textAlign: "justify"
              }}
            >
              In relation to CONTRACTOR’s compensation, CARRIER will permit
              CONTRACTOR to examine copies of CARRIER’s tariff or other documents
              from which rates and charges are computed, provided that where rates
              or charges are computed from a contract, only those portions of the
              contract containing the same information that would appear on a
              rated freight bill will be disclosed. CARRIER may delete the names
              of shippers and consignees shown on the freight bill or other form
              of documentation.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(c)">
            <p
              style={{
                paddingLeft: "23pt",
                textIndent: "71pt",
                textAlign: "justify"
              }}
            >
              In any case where amounts or payments are due to CARRIER from
              CONTRACTOR, under this Contract, CARRIER shall be authorized to
              deduct such amounts set forth and specified in Appendix 4, from
              CONTRACTOR’s settlements and/or Escrow Fund, as applicable. CARRIER
              shall provide to CONTACTOR a recitation as to how the amount of each
              item which is deducted is to be computed and shall, upon written
              request, provide to CONTRACTOR copies of those documents which are
              reasonably necessary to determine the validity of any such
              deductions. Following termination of this Contract, any net revenues
              owed but not yet paid to CONTRACTOR shall be deposited into
              CONTRACTOR’s Escrow Fund and CARRIER shall have a period of
              forty-five (45) days to verify the account of CONTRACTOR as to money
              owed to CARRIER by CONTRACTOR and to make appropriate final
              deductions from CONTRACTOR’s Escrow Fund before returning the Escrow
              Fund to CONTRACTOR. The cost of items provided by CARRIER to
              CONTRACTOR under his Contract shall be deducted from any final
              settlement if not returned to CARRIER within the forty-five (45) day
              period referenced above. The terms and provisions governing the
              Escrow Fund are set forth in Paragraph 14 of this Contract. CARRIER
              shall provide to CONTRACTOR a final accounting of all such final
              deductions made to the Escrow Fund. In no event shall the Escrow
              Fund be returned to CONTRACTOR later than forty-five (45) days from
              the termination date of the Contract.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(d)">
            <p
              style={{
                paddingLeft: "23pt",
                textIndent: "71pt",
                textAlign: "justify"
              }}
            >
              As a condition precedent to payment upon the termination of the
              Contract, CONTRACTOR shall remove all identification devices of
              CARRIER and, except in the case of identification painted directly
              on the Equipment, return them to CARRIER at CARRIER’s address as
              specified below in Paragraph 24. If the identification device has
              been lost or stolen, a letter certifying its removal will satisfy
              this requirement. Until this requirement is complied with, CARRIER
              may withhold final payment to CONTRACTOR.
            </p>
          </li>
          <li data-list-text="(e)">
            <p
              style={{
                paddingTop: "11pt",
                paddingLeft: "23pt",
                textIndent: "71pt",
                textAlign: "justify"
              }}
            >
              If CONTRACTOR fails to pay any amounts owed to CARRIER under this
              Contract when such amounts are due or if any amounts are still owed
              to CARRIER after the authorized deductions have been made as
              specified above, CONTRACTOR shall be obligated to pay such amounts
              to CARRIER, plus interest at a rate equal 2% per annum above the
              rate required to be paid on such overdue amount, and CONTRACTOR
              shall be liable for and pay to CARRIER any and all costs of
              collection of such amounts including attorney fees and costs
              incurred by CARRIER in collecting such amounts.
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text={5}>
        <h3
          style={{
            paddingTop: "4pt",
            paddingLeft: "23pt",
            textIndent: "35pt",
            textAlign: "justify"
          }}
        >
          <u>Legal&nbsp; Requirements&nbsp; of&nbsp; CONTRACTOR</u>.{" "}
          <span className="p">
            (a) CONTRACTOR recognizes that CARRIER'S business of providing motor
            carrier transportation services to the public is subject to regulation
            by the Federal government and that this Contract is governed by 49 CFR
            Part 376.1 et. seq., and by various Federal, state and local laws,
            rules and regulations (“Requirements”). In that regard, CONTRACTOR
            shall have the responsibility to satisfy the following Requirements:
            (i) maintaining the Equipment in the state of repair specified in the
            Requirements; (ii) allowing CARRIER to inspect the Equipment upon
            reasonable notice, as indicated in the Requirements; (iii) operating
            the Equipment in accordance with all applicable Requirements; and (iv)
            operating the Equipment with personnel furnished by CONTRACTOR that
            meet and satisfy the driver qualifications of the FMCSA, the DOT and
            all other Requirements.
          </span>
        </h3>
        <ol id="l3">
          <li data-list-text="(b)">
            <p
              style={{
                paddingTop: "11pt",
                paddingLeft: "23pt",
                textIndent: "71pt",
                textAlign: "justify"
              }}
            >
              Without limiting the foregoing, CONTRACTOR agrees to operate the
              Equipment at all times in accordance with the laws, rules and
              regulations of the various jurisdictions in which the Equipment will
              be operated and pursuant to any and all applicable operating
              authorities of CARRIER, and in accordance with all laws, rules and
              regulations related to traffic safety, highway protection and road
              requirements, including prohibitions related to the possession of
              controlled substances, including alcohol, while utilizing or
              operating the Equipment. CONTRACTOR represents and warrants that the
              Equipment shall have a gross weight of not greater than 19,000
              pounds. The parties specifically agree that a violation by
              CONTRACTOR of any law, rule or regulation governing operations
              performed under this Contract shall be deemed to be a material
              breach of the Contract under Paragraph 20.B. CONTRACTOR further
              agrees to operate the Equipment at all times in the manner and
              procedures as may be required by CARRIER’s shippers, customers,
              consignees, or service providers.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text={6}>
        <h3
          style={{
            paddingLeft: "23pt",
            textIndent: "35pt",
            textAlign: "justify"
          }}
        >
          <u>CARRIER and Equipment</u>.{" "}
          <span className="p">
            The parties acknowledge CARRIER’s obligation to fulfill the
            requirements of 49 CFR Sec. 376.12(c)(1) by having “exclusive
            possession, control and use of” the Equipment and assuming “complete
            responsibility for the operation of” the Equipment during the term of
            the Contract. As part of CARRIER’s responsibility regarding operation
            of the equipment pursuant to 49 CFR Sec. 376.12(c)(1), CONTRACTOR
            acknowledges, agrees, and consents to CARRIER’s capture, transmission,
            collection, and review of any available data from any devices or
            applications installed or affixed to the Equipment, whether installed
            or affixed now or in the future, and CARRIER may use any such data to
            verify compliant operation of the Equipment, fitness for hauling under
            CARRIER’S authority, and compliance with the terms of this Agreement
            (“Operational Audit”). The parties agree that any violation of this
            Agreement or any applicable law, rule, or regulation discovered by
            Operational Audit, shall be deemed a material breach of the Contract
            under Paragraph 20.B.
          </span>
        </h3>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <p
          style={{
            paddingLeft: "23pt",
            textIndent: "38pt",
            textAlign: "justify"
          }}
        >
          Without limiting the foregoing, except where required to ensure
          compliant operation of the Equipment, nothing herein (including without
          limitation Section 7 below) shall vest in CARRIER any control over the
          Equipment beyond that which is required to comply with the
          above-referenced regulation.{" "}
          <b>
            Moreover, this requirement relates solely to the Equipment and does
            not create or imply any control over CONTRACTOR by CARRIER regarding
            CONTRACTOR’s operation of the Equipment. Pursuant to 49 C.F.R. §
            376.12(c)(4), nothing in this provision is intended to affect whether
            CONTRACTOR is an independent contractor of CARRIER. An independent
            contractor relationship between CARRIER and CONTRACTOR may exist when
            CARRIER complies with 49 U.S.C. 14102 and its attendant requirements.
          </b>
        </p>
      </li>
      <li data-list-text={7}>
        <h3
          style={{
            paddingTop: "11pt",
            paddingLeft: "23pt",
            textIndent: "35pt",
            textAlign: "justify"
          }}
        >
          <u>Independent Contractor Status</u>.{" "}
          <span className="p">
            (a) CONTRACTOR shall perform services under this Contract according to
            CONTRACTOR’S own methods and means and will not be subject to the
            control, supervision or direction of CARRIER regarding the performance
            of CONTRACTOR’S services under this Contract. The parties therefore
            agree that CONTRACTOR shall perform services under this Contract as an
            independent contractor and agree as follows:
          </span>
        </h3>
        <ol id="l4">
          <li data-list-text="A.">
            <p
              style={{
                paddingTop: "11pt",
                paddingLeft: "55pt",
                textIndent: "-36pt",
                textAlign: "left"
              }}
            >
              CONTRACTOR has been and will continue to be free from control or
              direction in connection with the performance of the services, both
              under the Contract and in fact;
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="B.">
            <p
              style={{
                paddingLeft: "55pt",
                textIndent: "-36pt",
                textAlign: "left"
              }}
            >
              the services of CONTRACTOR are performed outside the usual course of
              the business of CARRIER and are performed outside of all the places
              of business of CARRIER;
            </p>
          </li>
          <li data-list-text="C.">
            <p
              style={{
                paddingTop: "4pt",
                paddingLeft: "55pt",
                textIndent: "-36pt",
                textAlign: "justify"
              }}
            >
              CONTRACTOR is customarily engaged in the independently established
              trade, occupation, profession or business of transporting freight by
              motor vehicle;
            </p>
          </li>
          <li data-list-text="D.">
            <p
              style={{
                paddingTop: "11pt",
                paddingLeft: "55pt",
                textIndent: "-36pt",
                textAlign: "justify"
              }}
            >
              On the effective date of the Contract, CONTRACTOR is responsible for
              filing, at the next applicable filing period, a schedule of expenses
              associated with CONTRACTOR’s business with the Internal Revenue
              Service for the type of business CONTRACTOR is conducting;
            </p>
          </li>
          <li data-list-text="E.">
            <p
              style={{
                paddingTop: "11pt",
                paddingLeft: "55pt",
                textIndent: "-36pt",
                textAlign: "justify"
              }}
            >
              CONTRACTOR has a principal place of business for the work CONTRACTOR
              is conducting that is eligible for a business deduction for federal
              income tax purposes;
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="F.">
            <p
              style={{
                paddingLeft: "55pt",
                textIndent: "-36pt",
                textAlign: "justify"
              }}
            >
              CONTRACTOR has the right to accept or reject, without penalty, any
              shipment offered for transportation by CARRIER.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="G.">
            <p
              style={{
                paddingLeft: "55pt",
                textIndent: "-36pt",
                textAlign: "justify"
              }}
            >
              CONTRACTOR has the right to determine the actual route of travel
              taken in transporting any cargo shipment for or on behalf of CARRIER
              and at what point and locations drivers shall take rest stops and
              refuel.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="H.">
            <p
              style={{
                paddingLeft: "55pt",
                textIndent: "-36pt",
                textAlign: "justify"
              }}
            >
              CONTRACTOR shall determine CONTRACTOR’S hours of operation, except
              that CONTRACTOR must achieve the result of picking up and delivering
              the cargo on a timely basis, if so required by the shipper or
              consignee.
            </p>
          </li>
          <li data-list-text="I.">
            <p
              style={{
                paddingTop: "11pt",
                paddingLeft: "55pt",
                textIndent: "-36pt",
                textAlign: "justify"
              }}
            >
              CONTRACTOR is responsible for proper and secure loading and
              providing and paying for labor to load, unload and transport
              commodities and freight.
            </p>
          </li>
          <li data-list-text="J.">
            <p
              style={{
                paddingTop: "11pt",
                paddingLeft: "55pt",
                textIndent: "-36pt",
                textAlign: "justify"
              }}
            >
              CONTRACTOR warrants and represents that he or she has made a
              substantial investment in his or her own independent business of
              transporting freight by motor vehicle.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="K.">
            <p
              style={{
                paddingLeft: "55pt",
                textIndent: "-36pt",
                textAlign: "justify"
              }}
            >
              CONTRACTOR has the right under this Contract and may transport
              freight for carriers, shippers, consignors, consignees, brokers and
              entities other than CARRIER. In the event CONTRACTOR moves freight
              for an entity other than CARRIER, all applicable liability insurance
              requirements and appropriate operating authority from FMCSA must be
              independently acquired by CONTRACTOR at CONTRACTOR’s sole expense.
              CONTRACTOR shall remove from the Equipment any and all
              identification and documentation relating to CARRIER if, during the
              term of this Contract, CONTRACTOR determines to use the Equipment to
              provide transportation services for a carrier other than CARRIER.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="L.">
            <p
              style={{
                paddingLeft: "94pt",
                textIndent: "-35pt",
                textAlign: "left"
              }}
            >
              CONTRACTOR shall be solely responsible for:
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
            <ol id="l5">
              <li data-list-text="i.">
                <p
                  style={{
                    paddingLeft: "75pt",
                    textIndent: "-40pt",
                    textAlign: "justify"
                  }}
                >
                  Paying all expenses incurred in providing services under the
                  Contract, including but not limited to expenses related to the
                  operation of the Equipment, including maintenance and repair
                  costs;
                </p>
              </li>
              <li data-list-text="ii.">
                <p
                  style={{
                    paddingTop: "11pt",
                    paddingLeft: "75pt",
                    textIndent: "-43pt",
                    textAlign: "justify"
                  }}
                >
                  Selecting, retaining, controlling, compensating and terminating
                  all Workers CONTRACTOR utilizes in performing services under the
                  Contract;
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
              <li data-list-text="iii.">
                <p
                  style={{
                    paddingLeft: "75pt",
                    textIndent: "-45pt",
                    textAlign: "justify"
                  }}
                >
                  Self-scheduling of his or her work hours and the work hours of
                  CONTRACTOR’s Workers;
                </p>
              </li>
              <li data-list-text="iv.">
                <p
                  style={{
                    paddingTop: "11pt",
                    paddingLeft: "75pt",
                    textIndent: "-45pt",
                    textAlign: "justify"
                  }}
                >
                  Selecting and controlling the methods and means used to provide
                  services under the Contract;
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
              <li data-list-text="v.">
                <p
                  style={{
                    paddingLeft: "75pt",
                    textIndent: "-43pt",
                    textAlign: "justify"
                  }}
                >
                  Furnishing at CONTRACTOR’s sole expense, all tools, equipment
                  and supplies necessary to provide services under the Contract;
                </p>
              </li>
              <li data-list-text="vi.">
                <p
                  style={{
                    paddingTop: "4pt",
                    paddingLeft: "75pt",
                    textIndent: "-45pt",
                    textAlign: "left"
                  }}
                >
                  Satisfying all obligations concerning applicable taxes; and
                </p>
              </li>
              <li data-list-text="vii.">
                <p
                  style={{
                    paddingTop: "11pt",
                    paddingLeft: "75pt",
                    textIndent: "-48pt",
                    textAlign: "justify"
                  }}
                >
                  Complying with all laws, rules, regulations and ordinances of
                  Federal, state, county, municipal and local government relating
                  to CONTRACTOR’S performance under the Contract;
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
            </ol>
          </li>
          <li data-list-text="M.">
            <p
              style={{
                paddingLeft: "94pt",
                textIndent: "-35pt",
                textAlign: "left"
              }}
            >
              CONTRACTOR will not:
            </p>
            <ol id="l6">
              <li data-list-text="i.">
                <p
                  style={{
                    paddingTop: "11pt",
                    paddingLeft: "75pt",
                    textIndent: "-41pt",
                    textAlign: "justify"
                  }}
                >
                  be required to comply with any instructions from CARRIER as to
                  when, where and how the services under this Contract are to be
                  performed, except that CONTRACTOR will comply with applicable
                  law and CONTRACTOR may be subject to Operational Audit by
                  CARRIER;
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
              <li data-list-text="ii.">
                <p
                  style={{
                    paddingLeft: "75pt",
                    textIndent: "-43pt",
                    textAlign: "justify"
                  }}
                >
                  except as may be facilitated in connection with a Training
                  Services Agreement, receive any training from CARRIER or its
                  employees through correspondence, mandatory meetings or
                  otherwise relating to the services performed by CONTRACTOR;
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
              <li data-list-text="iii.">
                <p
                  style={{
                    paddingLeft: "75pt",
                    textIndent: "-45pt",
                    textAlign: "justify"
                  }}
                >
                  except as may be agreed between the parties in a Training
                  Services Agreement, be required to perform services under this
                  Contract on the premises of CARRIER and CONTRACTOR, not CARRIER,
                  will control the order or sequence by which the services are
                  performed;
                </p>
              </li>
              <li data-list-text="iv.">
                <p
                  style={{
                    paddingTop: "11pt",
                    paddingLeft: "75pt",
                    textIndent: "-46pt",
                    textAlign: "justify"
                  }}
                >
                  be required to submit regular or written reports to CARRIER
                  related to the performance of services under this Contract,
                  except as provided under any applicable Training Services
                  Agreement; and
                </p>
              </li>
              <li data-list-text="v.">
                <p
                  style={{
                    paddingTop: "11pt",
                    paddingLeft: "75pt",
                    textIndent: "-43pt",
                    textAlign: "justify"
                  }}
                >
                  be paid or reimbursed for business, travel, or other expenses
                  related to the performance of services under this Contract.
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
            </ol>
          </li>
          <li data-list-text="N.">
            <p
              style={{
                paddingLeft: "55pt",
                textIndent: "-36pt",
                textAlign: "justify"
              }}
            >
              CONTRACTOR and/or CONTRACTOR’S Workers will not be eligible for, or
              receive, any benefits provided by CARRIER to its employees and
              CONTRACTOR hereby specifically waives and declines all such
              benefits, even if CONTRACTOR and/or CONTRACTOR’S Workers are
              determined or adjudged to be an employee of CARRIER for any purpose,
              including under common law or statutory law. CONTRACTOR will
              receive, where required, and CARRIER will file with the IRS, FORM
              1099 regarding payments made to CONTRACTOR under this Contract.
            </p>
          </li>
        </ol>
        <h3
          style={{
            paddingTop: "11pt",
            paddingLeft: "23pt",
            textIndent: "35pt",
            textAlign: "justify"
          }}
        >
          (b) THE PARTIES ACKNOWLEDGE AND AGREE THAT COMPLIANCE WITH THE
          REQUIREMENTS OF 49 C.F.R. §376.1, ET. SEQ. AND 49 U.S.C. §14102, AND ITS
          ATTENDANT ADMINISTRATIVE REQUIREMENTS, SHALL NOT AFFECT CONTRACTOR’S
          STATUS AS AN INDEPENDENT CONTRACTOR, THAT THOSE SECTIONS ARE NOT
          INTENDED TO AFFECT WHETHER CONTRACTOR IS AN INDEPENDENT CONTRACTOR OR
          EMPLOYEE AND THE PARTIES SPECIFICALLY ACKNOWLEDGE AND AGREE THAT
          CONTRACTOR SHALL AT ALL TIMES OCCUPY THE STATUS OF AN INDEPENDENT
          CONTRACTOR. <span className="p">CONTRACTOR’S services for</span>
        </h3>
        <p
          style={{ paddingLeft: "23pt", textIndent: "0pt", textAlign: "justify" }}
        >
          CARRIER under the Contract are exempt from Tennessee’s workers
          compensation law pursuant to T.C.A.
        </p>
        <p
          style={{ paddingLeft: "23pt", textIndent: "0pt", textAlign: "justify" }}
        >
          §50-6-102 (12)(D)(i). CONTRACTOR’s services for CARRIER under the
          Contract are exempt from Tennessee’s unemployment insurance law pursuant
          to T.C.A. §50-7-207(e)(1) and CONTRACTOR operates as an independent
          contractor under the twenty (20) factors referenced in T.C.A. §50-7-
          207(b)(2)(B)(i)-(xx).
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={8}>
        <h3
          style={{
            paddingLeft: "23pt",
            textIndent: "35pt",
            textAlign: "justify"
          }}
        >
          <u>CONTRACTOR’s Responsibilities</u>.{" "}
          <span className="p">
            CONTRACTOR shall have sole and exclusive responsibility for the
            following:
          </span>
        </h3>
        <ol id="l7">
          <li data-list-text="A.">
            <p
              style={{
                paddingTop: "11pt",
                paddingLeft: "55pt",
                textIndent: "-36pt",
                textAlign: "justify"
              }}
            >
              Hiring, setting wages, hours and working conditions for, adjusting
              the grievances of, supervising, training, compensating, controlling,
              disciplining and terminating all Workers,
            </p>
            <p
              style={{
                paddingTop: "4pt",
                paddingLeft: "55pt",
                textIndent: "0pt",
                textAlign: "justify"
              }}
            >
              necessary for the performance of CONTRACTOR'S obligations under this
              Contract, provided that CONTRACTOR’S drivers have met the
              requirements of Federal and state regulations dealing with driver
              qualifications in accordance with Paragraph 8.(I) below. Except as
              otherwise agreed to in a Training Services Agreement, Workers
              utilized by CONTRACTOR for the performance of CONTRACTOR'S
              obligations under the Contract are and shall remain the employees or
              contractors of CONTRACTOR, are not the employees or contractors of
              CARRIER and CARRIER shall not be considered to be a joint employer
              of such Workers;
            </p>
          </li>
          <li data-list-text="B.">
            <p
              style={{
                paddingTop: "11pt",
                paddingLeft: "55pt",
                textIndent: "-36pt",
                textAlign: "justify"
              }}
            >
              In compliance with all applicable law, maintaining in force at all
              times required Workers' Compensation insurance, or, if accepted,
              occupational accident insurance instead of Workers' Compensation
              insurance coverage (and in such case, provide sufficient notice to
              CARRIER to include such Worker in CARRIER’s roster of enrolled
              drivers to the extent CONTRACTOR utilizes occupational accident
              insurance through CARRIER), on all Workers, as applicable, used by
              CONTRACTOR in the performance of this Contract.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="C.">
            <p
              style={{
                paddingLeft: "55pt",
                textIndent: "-36pt",
                textAlign: "justify"
              }}
            >
              For purposes of this sub-section and Paragraph 11 below, CONTRACTOR
              shall not be required to purchase any insurance coverage from or
              through CARRIER. In addition to the insurance requirements set forth
              in Section 11 below, CONTRACTOR shall procure, carry, maintain and
              pay for commercial automobile liability insurance (personal injury
              and property damage) which shall provide coverage to CONTRACTOR
              whenever the Equipment (as well as any of CARRIER’s trailers or
              CARRIER’s customer’s trailers) is being operated on behalf of
              CARRIER, in a combined single limit of not less than Two Hundred
              Fifty Thousand Dollars ($250,000), with a deductible of no more than
              $1000.00, for injury or death to any person or for damage to any
              property in any one occurrence. Such coverage shall be no less
              comprehensive than the coverage CARRIER may facilitate on
              CONTRACTOR’s behalf and at CONTRACTOR’s election, including
              uninsured/underinsured motorist coverage equal to that under
              CARRIER’s commercial automobile liability policy. In addition, such
              coverage shall be primary, as between CARRIER and CONTRACTOR to any
              other insurance that may be available to CARRIER. CONTRACTOR shall
              be responsible for paying all deductible amounts. Such policy shall
              be underwritten by a company which has an AM Best rating of A- or
              better. Such policy must be underwritten on the ISO Motor Carrier
              Form. Additionally, the policy must be a scheduled auto policy which
              includes language for a substitute auto. CARRIER must be named as an
              additional insured on the policy as evidenced by an endorsement
              issued by the insurance carrier or insurer. CONTRACTOR shall also
              procure, carry, maintain and pay for physical damage insurance, as
              indicated in Appendix 4 at Paragraph Q, with coverage and deductible
              amounts specified by CARRIER at the time of the execution of this
              Contract and from time to time thereafter.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="D.">
            <p
              style={{
                paddingLeft: "55pt",
                textIndent: "-36pt",
                textAlign: "justify"
              }}
            >
              Except as otherwise agreed to in a Training Services Agreement,
              filing all Federal, state and local income, withholding, employment
              and Federal highway use tax forms and returns and fuel tax filings,
              which may be required by law to file, on account of CONTRACTOR’s
              business and all Workers used by CONTRACTOR in the performance of
              this Contract, at the time, place and manner which may be specified
              in the applicable Federal, state and local laws, and to pay when due
              all taxes and contributions reported in such forms and returns.
            </p>
          </li>
          <li data-list-text="E.">
            <p
              style={{
                paddingTop: "11pt",
                paddingLeft: "94pt",
                textIndent: "-35pt",
                textAlign: "left"
              }}
            >
              Selecting, leasing, purchasing, financing, maintaining and repairing
              the Equipment.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="F.">
            <p
              style={{
                paddingLeft: "55pt",
                textIndent: "-36pt",
                textAlign: "justify"
              }}
            >
              Paying all operating expenses, including but not limited to fuel,
              maintenance, repairs, equipment required for electronic logging
              compliance, the cost of fuel, fuel taxes, empty mileage, permits of
              all types, tolls, ferries, detention and accessorial services, base
              plates, licenses, and all unused portions of such items, highway
              taxes and scale tickets, motel charges and charges due to breakdown
              of the Equipment (including rental charges), taxes, apportioned
              taxes, drug and alcohol testing, fines which are a result of the
              acts or
            </p>
            <p
              style={{
                paddingTop: "4pt",
                paddingLeft: "55pt",
                textIndent: "0pt",
                textAlign: "justify"
              }}
            >
              omissions of CONTRACTOR for parking, moving or weight violations,
              licenses, permits, sales taxes or any fines, penalties, levies or
              assessments based upon the operating authority of CARRIER and its
              connecting carriers or the operating authority of CONTRACTOR, as
              applicable, with the exception, and subject in each case only to any
              regulatory requirements which may be placed on CARRIER by various
              governmental agencies and under 49 CFR Sec.376.12, et seq. Any pro
              rata refund of licenses, plates and permits to CONTRACTOR upon
              termination of this Contract, shall be determined by the amount
              CONTRACTOR could obtain as a refund on the date the licenses, plates
              and permits are received by CARRIER at CARRIER’S address as
              indicated in Paragraph 24 below. CONTRACTOR recognizes that some
              states give no refund and others only a partial or reduced refund.
              If CARRIER is authorized to receive a refund or credit for base
              plates purchased by CONTRACTOR from, and issued in the name of,
              CARRIER or if the base plates are authorized to be sold by CARRIER
              to another contractor, CARRIER shall refund to CONTRACTOR on whose
              behalf the base plate was first obtained a prorate share of the
              amount received.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="G.">
            <p
              style={{
                paddingLeft: "55pt",
                textIndent: "-36pt",
                textAlign: "justify"
              }}
            >
              CONTRACTOR shall verify that all shipments are in compliance with
              the size and weight laws of the states in which CONTRACTOR will
              travel and to notify CARRIER if the Equipment is overweight or in
              need of permits before commencing the haul. Except when a violation
              results from the acts or omissions of CONTRACTOR or its Workers,
              CARRIER shall assume the risk and cost of fines for overweight and
              oversize trailers (i) when such trailers are preloaded, sealed or
              the load is containerized, (ii) for improperly permitted over-
              dimensional and overweight loads, or (iii) for any reason when the
              trailer or lading is otherwise outside of CONTRACTOR's control.
            </p>
          </li>
          <li data-list-text="H.">
            <p
              style={{
                paddingTop: "11pt",
                paddingLeft: "55pt",
                textIndent: "-36pt",
                textAlign: "justify"
              }}
            >
              CONTRACTOR agrees to defend, hold harmless, and indemnify CARRIER
              from and for any and all claims or actions by CONTRACTOR or
              CONTRACTOR’s Workers or by any Federal, state or local governmental
              agency on account of withholding and employment taxes, wage and hour
              or wage payment laws, rules or regulations, or any other claims or
              actions of any kind or nature arising from CONTRACTOR'S relationship
              with its Workers, including but not limited to all attorneys’ fees
              and costs incurred by CARRIER in defending any such claims and
              actions.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="I.">
            <p
              style={{
                paddingLeft: "55pt",
                textIndent: "-36pt",
                textAlign: "justify"
              }}
            >
              Except as otherwise agreed to in a Training Services Agreement,
              providing CARRIER with proof, as required by 49 CFR Parts 383, 391
              and 392, that all of CONTRACTOR’S drivers have met the requirements
              of Federal and state regulations dealing with driver qualifications
              and evidence of compliance with the foregoing. This required proof
              and evidence shall be updated when any change occurs such as
              violations or loss of license subsequent to the effective date of
              this Contract.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="J.">
            <p
              style={{
                paddingLeft: "55pt",
                textIndent: "-36pt",
                textAlign: "justify"
              }}
            >
              Having and maintaining a mobile communication device which is
              compatible and works with the mobile communication system used by
              CARRIER. CONTRACTOR acknowledges and agrees that the mobile
              communication device is necessary and required to satisfy the
              Federal mandate relating to CONTRACTOR’s possession and use of an
              electronic logging device. The lease or purchase and operation of
              the mobile communication device shall be at CONTRACTOR’s sole
              discretion and expense and CONTRACTOR may acquire such mobile
              communication device from any source of CONTRACTOR’s choosing,
              including CARRIER.
            </p>
          </li>
          <li data-list-text="K.">
            <p
              style={{
                paddingTop: "11pt",
                paddingLeft: "55pt",
                textIndent: "-36pt",
                textAlign: "justify"
              }}
            >
              Exercising all diligent efforts to conduct operations under this
              Contract to achieve the result of continued customer satisfaction.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="L.">
            <p
              style={{
                paddingLeft: "55pt",
                textIndent: "-36pt",
                textAlign: "justify"
              }}
            >
              Qualifying the Equipment, and any other equipment and drivers under
              CARRIER'S insurance carrier's requirements, as necessary.
            </p>
          </li>
          <li data-list-text="M.">
            <p
              style={{
                paddingTop: "4pt",
                paddingLeft: "55pt",
                textIndent: "-36pt",
                textAlign: "justify"
              }}
            >
              Keeping a copy of this Contract or a certificate in CONTRACTOR'S
              Equipment which identifies this Contract and contains the other
              information required under 49 C.F.R. Sec. 376.11(c)(2). The original
              version of the Contract shall be kept at the office of CARRIER and
              CONTRACTOR will be provided with a copy of the Contract as well.
            </p>
          </li>
          <li data-list-text="N.">
            <p
              style={{
                paddingTop: "11pt",
                paddingLeft: "55pt",
                textIndent: "-36pt",
                textAlign: "justify"
              }}
            >
              CONTRACTOR shall provide reasonable written notice to CARRIER of any
              passenger carried in the Equipment pursuant to the requirements of
              the FMCSA. CONTRACTOR shall provide passenger insurance, which may
              be purchased from any source of CONTRACTOR’s choosing, including
              CARRIER. CONTRACTOR will comply (and ensure that any passenger
              complies) with all applicable Federal and state laws, rules and
              regulations regarding the transportation of passengers by
              CONTRACTOR.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="O.">
            <p
              style={{
                paddingLeft: "55pt",
                textIndent: "-36pt",
                textAlign: "justify"
              }}
            >
              CONTRACTOR will collect and promptly remit to CARRIER any and all
              amounts paid to CONTRACTOR by consignor(s) or consignee(s) for
              transportation charges or otherwise. CONTRACTOR will be liable for
              any amounts which CONTRACTOR fails to remit to CARRIER or fails to
              collect from consignor(s) or consignee(s) unless otherwise
              instructed. Nothing contained in any provisions of this Contract
              shall be construed so as to make CARRIER or CONTRACTOR an agent for
              each other for any purpose whatsoever.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="P.">
            <p
              style={{
                paddingLeft: "55pt",
                textIndent: "-36pt",
                textAlign: "justify"
              }}
            >
              As provided in Section 6 of this Agreement, in the event
              CONTRACTOR’s Equipment is equipped with electronic devices which may
              record data and/or images concerning and/or related to events which
              occur during the operation of CONTRACTOR’s Equipment, CONTRACTOR
              agrees to permit CARRIER and/or its representatives, including but
              not limited to, its employees, attorneys, and representatives of its
              insurance carrier, to have access to and to take possession of such
              data or images as part of CARRIER’s Operational Audit. Additionally,
              in the event CONTRACTOR’S Equipment is involved in a motor vehicle
              accident or is alleged to have been involved in a motor vehicle
              accident, such data and/or images may be used if necessary, to
              defend CONTRACTOR and/or CARRIER against any claims which may be
              filed against CONTRACTOR and/or CARRIER. CONTRACTOR agrees to fully
              cooperate with and assist CARRIER and its representatives in
              obtaining said data and/or images.
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text={9}>
        <h3
          style={{
            paddingTop: "11pt",
            paddingLeft: "23pt",
            textIndent: "35pt",
            textAlign: "justify"
          }}
        >
          <u>DOT/FMCSA Driver Testing</u>.{" "}
          <span className="p">
            CONTRACTOR’s Workers are subject to all required DOT/FMCSA
            drug/alcohol testing to qualify to operate equipment and vehicles
            (including without limitation the Equipment) and disclosures and
            consents required by the Drug &amp; Alcohol Clearinghouse. Such
            testing shall include all tests required by Federal and state laws,
            rules and regulations, e.g., random, post-accident, reasonable
            suspicion, pre- employment (as the term “pre-employment” is used by
            the FMCSA regulations; does not denote or confer employment status),
            return to duty, follow up and periodic testing, as applicable.
            CONTRACTOR shall be responsible to assure that each driver is
            qualified through the DOT Drug/Alcohol Testing requirements under 49
            C.F.R. Parts 40 and 382. Costs for testing which is required by
            Federal or state laws, rules or regulations, incurred by either
            CONTRACTOR or CARRIER, will be paid by CONTRACTOR or assessed to
            CONTRACTOR and deducted from CONTRACTOR’s settlements and/or Escrow
            Fund. Any driver who is disqualified due to failure of testing or
            refusal of a test cannot operate the Equipment or any other equipment
            or vehicle under this Contract.
          </span>
        </h3>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={10}>
        <h3
          style={{
            paddingLeft: "23pt",
            textIndent: "35pt",
            textAlign: "justify"
          }}
        >
          <u>CONTRACTOR’S Waiver</u>.{" "}
          <span className="p">
            CONTRACTOR EXPRESSLY WAIVES ANY CLAIM OR ACTION, INCLUDING ATTORNEYS’
            FEES AND COSTS, AGAINST CARRIER AS A RESULT OF THE DEATH OR INJURY OF
            CONTRACTOR, CONTRACTOR'S WORKERS OR ANY OTHER PERSON OR ENTITY, OR
            DAMAGE TO THE EQUIPMENT OR PROPERTY OF CONTRACTOR, CONTRACTOR’S
            WORKERS OR OF ANY OTHER PERSON OR ENTITY, IN CONNECTION WITH THE
            PERFORMANCE OF CONTRACTOR OR CONTRACTOR’S WORKERS UNDER THE CONTRACT
            AND FURTHER AGREES TO DEFEND, HOLD HARMLESS AND INDEMNIFY CARRIER FROM
            AND FOR SUCH CLAIMS OR ACTIONS, INCLUDING ATTORNEYS’ FEES AND COSTS,
            EXCEPT FOR CLAIMS OF CARRIER’S NEGLIGENCE, AS DETERMINED BY A FINAL,
            NON-APPEALABLE ORDER OF A COURT OF COMPETENT JURISDICTION.
          </span>
        </h3>
      </li>
      <li data-list-text={11}>
        <h3
          style={{
            paddingTop: "4pt",
            paddingLeft: "23pt",
            textIndent: "35pt",
            textAlign: "justify"
          }}
        >
          <u>Insurance Coverage</u>.{" "}
          <span className="p">
            (a) CARRIER shall not be liable for any performance, services, actions
            or conduct of CONTRACTOR when not in the performance of services for
            CARRIER. CONTRACTOR agrees, at its own expense, to keep effective
            during the entire term of this Contract, a policy of business
            liability insurance which includes non-trucking liability and commuter
            endorsement (commuter endorsement defined as covering CONTRACTOR
            during trips to and from regular garaging location and CARRIER
            terminals), insuring CONTRACTOR is named insured and CARRIER is named
            as an additional insured against any such liability in such form and
            amount and with such insurance companies as shall be reasonably
            acceptable to CARRIER. A copy of such insurance policy shall be
            promptly delivered to CARRIER by CONTRACTOR. Any such insurance policy
            shall have a minimum Limit of Liability for Combined Single Limit of
            not less than one million dollars ($1,000,000.00) per occurrence as
            concerns the Equipment and all equipment hereunder when not used in
            performing services for CARRIER.
          </span>
        </h3>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <ol id="l8">
          <li data-list-text="(b)">
            <p
              style={{
                paddingLeft: "23pt",
                textIndent: "71pt",
                textAlign: "justify"
              }}
            >
              In addition to the insurance coverages required under this Contract,
              it is CONTRACTOR'S responsibility to procure, carry and maintain any
              fire, theft, uninsured and/or underinsured motorist, and physical
              damage (collision), or other insurance coverage that CONTRACTOR may
              deem necessary and appropriate for the Equipment or for CONTRACTOR's
              protection, health care or other needs. CONTRACTOR shall defend,
              hold harmless and indemnify CARRIER with respect to loss, theft or
              damage to CONTRACTOR's Equipment, trailer, or other equipment and
              property, and CARRIER has no responsibility to procure, carry, or
              maintain any insurance covering loss, theft or damage to
              CONTRACTOR's Equipment, trailer, or other equipment and property.
              CONTRACTOR acknowledges that CARRIER may, and CONTRACTOR hereby
              authorizes CARRIER to, waive and reject no-fault, uninsured, and
              underinsured motorist coverage from CARRIER's insurance policies to
              the extent allowed under applicable state law and CONTRACTOR shall
              cooperate in the completion of all necessary documentation for such
              waiver, election, or rejection. If CONTRACTOR chooses to purchase
              any insurance from or through CARRIER, CONTRACTOR shall be provided
              with a certificate of insurance for each such policy which contains
              the information required by 49 CFR 376.12(j)(2). Each certificate of
              insurance shall include the name of the insurer, the policy number,
              the effective dates of the policy, the amounts and types of
              coverage, the cost to CONTRACTOR for each type of coverage, and the
              deductible amount for each type of coverage for which CONTRACTOR may
              be liable. In addition, CARRIER shall provide CONTRACTOR with a copy
              of the applicable insurance policy upon CONTRACTOR's request.
              CONTRACTOR recognizes and agrees that CARRIER is not in the business
              of selling insurance, and any insurance coverage obtained through
              CARRIER is subject to all of the terms, conditions, limitations and
              exclusions of the actual policy issued by the insurance carrier or
              underwriter. After such policy or policies of insurance are issued,
              CONTRACTOR shall be responsible for paying for and maintaining such
              insurance and authorizes CARRIER to deduct the cost of insurance
              obtained through CARRIER from CONTRACTOR’s settlements and/or Escrow
              Fund hereunder.
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text={12}>
        <h3
          style={{
            paddingTop: "11pt",
            paddingLeft: "27pt",
            textIndent: "31pt",
            textAlign: "justify"
          }}
        >
          <u>Damage to Cargo</u>.{" "}
          <span className="p">
            Pursuant to FMCSA regulations under 49 U.S.C. 13906 CARRIER shall
            maintain in force insurance coverage for the protection of the public
            and public liability, property damage and cargo insurance coverage as
            concerns shippers and the general public. Moreover, CONTRACTOR shall
            defend, hold harmless and indemnify CARRIER from and for any loss or
            damage to third persons or property, which results from the operations
            of CONTRACTOR or its Workers under this Contract. However, the
            foregoing obligations will not be enforced if they have the effect of
            invalidating any insurance coverage required by this Contract. In
            addition, CONTRACTOR shall be responsible for and liable to CARRIER,
            and agrees to pay for shortage of, loss of, theft of or damage to
            cargo transported by CONTRACTOR under the Contract in the event that
            such shortage, theft, loss or damage is caused by the operation of
            CONTRACTOR or its Workers. Such monies shall be deducted from
            CONTRACTOR’s settlement, any monies due CONTRACTOR by CARRIER under
            this Contract and/or from CONTRACTOR’s Escrow Fund. Before deducting
            any such amounts from CONTRACTOR's settlements or Escrow Fund, CARRIER
            shall provide CONTRACTOR with a written explanation and itemization of
            any deductions made from CONTRACTOR’s settlements or Escrow Fund and
            an itemization of how the amount of each item deducted was computed.
            CONTRACTOR'S liability per occurrence for each type of claim arising
            out of an accident or loss as set forth above shall not exceed the
            amounts set forth in Appendix 4, with the exception that in the event
            of gross negligence or willful misconduct of CONTRACTOR, or its
            Workers, then CONTRACTOR's liability shall not be limited.
          </span>
        </h3>
      </li>
      <li data-list-text={13}>
        <h3
          style={{
            paddingTop: "4pt",
            paddingLeft: "23pt",
            textIndent: "35pt",
            textAlign: "justify"
          }}
        >
          <u>Accidents</u>.{" "}
          <span className="p">
            To insure compliance with governmental rules and regulations,
            CONTRACTOR shall immediately report any and all accidents to CARRIER
            irrespective of the amount of apparent damage caused by said accident.
            CONTRACTOR and its Workers shall cooperate fully with CARRIER and any
            applicable insurance carriers in documenting any such accident, in any
            investigation of such accident and with respect to any legal action,
            regulatory hearing or other proceeding arising from the operation of
            the Equipment, the relationship created by this Contract, or the
            services performed hereunder. CONTRACTOR shall, upon CARRIER's
            reasonable request and at CONTRACTOR's expense, provide reasonable
            assistance in such legal action or other proceeding, attend
            depositions, hearings and trials, and assist in securing evidence or
            obtaining the attendance of witnesses.
          </span>
        </h3>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={14}>
        <p
          style={{
            paddingLeft: "23pt",
            textIndent: "35pt",
            textAlign: "justify"
          }}
        >
          <u>
            <b>Escrow Fund</b>
          </u>
          <b>. </b>Performance Bond. CONTRACTOR shall deposit into an escrow fund
          to be maintained with CARRIER (the “Escrow Fund”), established at the
          commencement of this Contract, a performance cash bond in the total
          amount of $
          <span className="s9"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
          <u>25,000 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u>, as indicated in
          this paragraph, for each tractor covered by this Contract. For clarity,
          such Escrow Fund is established at commencement of this Contract but may
          not be required to be fully funded at such time, instead, to be funded
          over time as set forth herein and in Appendix 4. The following terms
          apply to the Escrow Fund:
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <ol id="l9">
          <li data-list-text="i.">
            <p
              style={{
                paddingLeft: "55pt",
                textIndent: "-36pt",
                textAlign: "justify"
              }}
            >
              For each tractor covered by this Contract, CARRIER is authorized to
              deduct $<u> {props.viewObject !== undefined ? props.viewObject.deduct : props.escrow} </u>
              /mile from each settlement due CONTRACTOR and deposit the same into
              the Escrow Fund. The Escrow Fund shall guarantee performance called
              for by this Contract and may be used by CARRIER to pay any financial
              obligations of CONTRACTOR under this Contract, including cash
              advances, fuel, fines, licenses, permits, road taxes, mileage taxes,
              fuel taxes, highway use taxes, tolls, ferries, base plates,
              authorized insurance deductions, accident claims and charges, cargo
              damage claims, claims due to theft or pilferage, driver testing and
              examination costs, noncompliance reserves and other expenses which
              are the obligation of CONTRACTOR, those fines, penalties, interest,
              taxes, fees and assessments levied on CARRIER as a result of
              CONTRACTOR’S operation, amounts under Paragraph 8.F., and the
              deductions specified in Appendix 4 to this Contract.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="ii.">
            <p
              style={{
                paddingLeft: "55pt",
                textIndent: "-38pt",
                textAlign: "justify"
              }}
            >
              CARRIER will provide CONTRACTOR an accounting of any and all
              transactions involving such Escrow Fund by clearly indicating on
              CONTRACTOR settlement sheets the amount and description of any
              deduction or addition made to the Escrow Fund. In addition,
              CONTRACTOR may at any time demand to have an accounting for any
              transactions involving the Escrow Fund.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="iii.">
            <p
              style={{
                paddingLeft: "55pt",
                textIndent: "-40pt",
                textAlign: "justify"
              }}
            >
              While this Escrow Fund is under the control of CARRIER, CARRIER
              shall pay interest on the Escrow Fund upon termination of this
              Contract, which interest shall be credited to the Escrow Fund on a
              quarterly basis at the 91-day, 13-week Treasury bill rate as
              established in the weekly auction by the U.S. Department of Treasury
              prevailing at the beginning of each quarter. For purposes of
              calculating the balance of the Escrow Fund on which interest must be
              paid, CARRIER may deduct a sum equal to the average advance made to
              CONTRACTOR during the period of time for which interest is paid.
            </p>
          </li>
          <li data-list-text="iv.">
            <p
              style={{
                paddingTop: "11pt",
                paddingLeft: "55pt",
                textIndent: "-41pt",
                textAlign: "justify"
              }}
            >
              At the option of CONTRACTOR and subject to approval by CARRIER,
              CONTRACTOR may deposit additional monies into the Escrow Fund over
              and above the requirements of CARRIER by providing Notice to
              CONTRACTOR pursuant to Section 24 of this Agreement, and shall
              include in such Notice the effective date and amount of any such
              additional monies. The terms and conditions of this paragraph shall
              apply to any additional funds deposited by CONTRACTOR.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="v.">
            <p
              style={{
                paddingLeft: "55pt",
                textIndent: "-39pt",
                textAlign: "justify"
              }}
            >
              CARRIER will, within forty-five (45) days after termination of this
              Contract, return said Escrow Fund to CONTRACTOR less any deductions
              for those obligations incurred by CONTRACTOR which have been
              previously specified in this Contract and Appendix 4, and shall
              provide a final accounting to CONTRACTOR for all such final
              deductions from the Escrow Fund. In no event shall the Escrow Fund
              be returned to CONTRACTOR later than forty-five (45) days from the
              date of termination of the Contract;. Both parties agree that
            </p>
          </li>
        </ol>
        <p
          style={{
            paddingTop: "4pt",
            paddingLeft: "55pt",
            textIndent: "0pt",
            textAlign: "left"
          }}
        >
          Escrow Fund deductions will be deemed to have been effected on the date
          the obligation was incurred.
        </p>
      </li>
      <li data-list-text={15}>
        <h3
          style={{
            paddingTop: "11pt",
            paddingLeft: "23pt",
            textIndent: "35pt",
            textAlign: "justify"
          }}
        >
          <u>Third-Party&nbsp; Obligations&nbsp; of&nbsp; CONTRACTOR</u>.{" "}
          <span className="p">
            CONTRACTOR and CARRIER acknowledge that CONTRACTOR may have
            indebtedness or obligations to third parties whereby CONTRACTOR, with
            the consent of CARRIER, has agreed to have sums deducted from
            CONTACTOR’s settlement(s) or Escrow Fund to satisfy such indebtedness
            or obligations. CONTRACTOR hereby authorizes CARRIER to deduct any
            such indebtedness or obligations from CONTRACTOR’s settlement(s) or
            Escrow Fund. To the extent that CONTRACTOR is leasing and/or
            purchasing the Equipment from a third party under the terms of a
            written contract or agreement, CONTRACTOR, with the consent of
            CARRIER, agrees that CARRIER may deduct all payments and charges under
            such a contract or agreement from CONTRACTOR’s settlement(s) or Escrow
            Fund and provide them directly to such third party.
          </span>
        </h3>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={16}>
        <h3
          style={{
            paddingLeft: "23pt",
            textIndent: "35pt",
            textAlign: "justify"
          }}
        >
          <u>CARRIER Property</u>.{" "}
          <span className="p">
            CONTRACTOR is not required to purchase or rent any products, equipment
            or services from CARRIER as a condition of entering into this
            Contract. If any equipment or other property is furnished by CARRIER
            to CONTRACTOR for use in the performance of this Contract, CONTRACTOR
            shall return such property to CARRIER in the same condition as when
            received by CONTRACTOR, reasonable wear and tear excepted, at a
            location agreed to by the parties or if no agreement is reached, then
            the location where the equipment was obtained by CONTRACTOR. If
            CONTRACTOR fails to return such property, CONTRACTOR shall be liable
            for its replacement cost. In the event CONTRACTOR for any reason fails
            to return CARRIER's property upon CARRIER's request or upon
            termination of this Contract, CONTRACTOR agrees to reimburse CARRIER
            for all reasonable expenses incurred by CARRIER in recovering the
            property including but not limited to attorneys’ fees and costs.
            CONTRACTOR agrees that in the event it is necessary for CARRIER to
            enter upon private property or remove private property in order to
            recover CARRIER’s property from CONTRACTOR, CONTRACTOR does hereby
            irrevocably grant CARRIER or its duly authorized agents, permission to
            do so and further agrees to defend, hold harmless and indemnify
            CARRIER, or its duly authorized agents, from and for any form of
            liability whatsoever in connection with such repossession. CONTRACTOR
            agrees and warrants that any trailer or property provided by CARRIER
            will be used by CONTRACTOR and its Workers only to transport shipments
            tendered to CONTRACTOR by CARRIER, and in the event of violation of
            this prohibition, CONTRACTOR agrees to defend, hold harmless and
            indemnify CARRIER, or its duly authorized agents, from and for any
            form of liability whatsoever in connection with such violation. In the
            event CONTRACTOR elects to purchase or rent equipment, products or
            services from CARRIER or from any third party, under a purchase or
            rental contract, which such contract shall permit such carrier the
            right to make deductions from CONTRACTOR's settlements and/or Escrow
            Fund, and such purchase or rental contract(s) shall be attached to
            this Contract as separate appendices and are hereby incorporated into
            the Contract by this reference.
          </span>
        </h3>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={17}>
        <h3
          style={{
            paddingLeft: "23pt",
            textIndent: "35pt",
            textAlign: "justify"
          }}
        >
          <u>Identification and Advertising</u>.{" "}
          <span className="p">
            (a) During the term of the Contract, CARRIER shall furnish
            identification for the Equipment in accordance with the FMCSA’s
            requirements in part 390 (Identification of Vehicles). CONTRACTOR
            agrees to permit CARRIER to identify the Equipment and display such
            identification thereon in the manner required by all applicable laws,
            rules or regulations. Immediately upon the termination of this
            Contract, CONTRACTOR shall remove from the Equipment at CONTRACTOR’s
            cost and expense all signs or other identification referring to
            CARRIER and shall also immediately surrender to CARRIER all shipping
            documents, licenses, plates, permits, stickers, operating authorities
            of CARRIER, equipment and any and all other materials and things
            furnished, provided or rented to CONTRACTOR by CARRIER.
          </span>
        </h3>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <ol id="l10">
          <li data-list-text="(b)">
            <p
              style={{
                paddingLeft: "23pt",
                textIndent: "71pt",
                textAlign: "justify"
              }}
            >
              CONTRACTOR shall permit and allow CARRIER to display from time to
              time advertising on trailers used by CONTRACTOR in the performance
              of this Contract at CARRIER’s sole expense and liability. Upon the
              termination of this Contract the removal of all such advertising
              shall be the sole responsibility of CARRIER and shall be removed at
              the sole cost and expense of CARRIER.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text={18}>
        <h3
          style={{
            paddingLeft: "23pt",
            textIndent: "35pt",
            textAlign: "justify"
          }}
        >
          <u>
            Failure&nbsp; to&nbsp; Perform&nbsp; by&nbsp; CONTRACTOR;&nbsp;
            Audit&nbsp; Rights
          </u>
          .{" "}
          <span className="p">
            (a) If for any reason, CONTRACTOR or its Workers shall fail to
            complete transportation of commodities or freight in transit, or
          </span>
        </h3>
        <p
          style={{
            paddingTop: "4pt",
            paddingLeft: "23pt",
            textIndent: "0pt",
            textAlign: "justify"
          }}
        >
          abandon a shipment or otherwise subject CARRIER to liability to shippers
          or governmental agencies on account of the acts or omissions of
          CONTRACTOR or CONTRACTOR’s Workers en route, CONTRACTOR expressly agrees
          that CARRIER shall have the right to complete performance using the
          Equipment or any other equipment, and CONTRACTOR shall be liable for the
          cost of CARRIER in completing such performance, and shall pay such
          amounts to CARRIER upon demand for payment by CARRIER and further agrees
          that CARRIER has authority to deduct such amounts from the Escrow Fund.
          CONTRACTOR expressly waives any defenses CONTRACTOR may have in that
          regard.
        </p>
        <ol id="l11">
          <li data-list-text="(b)">
            <p
              style={{
                paddingTop: "11pt",
                paddingLeft: "23pt",
                textIndent: "71pt",
                textAlign: "justify"
              }}
            >
              CONTRACTOR grants CARRIER an express right to inspect the Equipment,
              records, documentation, and any other available information at a
              location determined within CARRIER’S discretion in order to verify
              compliance under this Contract, fitness for hauling under CARRIER’S
              authority, or any other reasonable purpose CARRIER may determine in
              its discretion.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text={19}>
        <h3
          style={{
            paddingLeft: "23pt",
            textIndent: "35pt",
            textAlign: "justify"
          }}
        >
          <u>Unscheduled Payments</u>.{" "}
          <span className="p">
            Payments made from CARRIER TO CONTRACTOR beyond those set forth in
            Appendix 3 shall be negotiated between the parties and determined on a
            case-by-case basis and the amount and/or calculation for such payment
            shall be specified 1) in a separate written addendum which will be
            provided to CONTRACTOR prior to the commencement of any trip for which
            such payments will be made; OR 2) with notice as provided in Paragraph
            24 of this Agreement. Any payments made by CARRIER to CONTRACTOR for
            services and equipment beyond the payment schedule set forth in
            Appendix 3 shall not be construed to create a contractual or other
            right in CONTRACTOR to receive such payments in the future or on an
            ongoing basis. CARRIER shall not be responsible to compensate or
            reimburse CONTRACTOR for any charges related to detention, layover or
            other accessorial services other than specifically provided herein. In
            order to receive any unscheduled payments pursuant to this Section,
            CONTRACTOR must provide to CARRIER within two (2) weeks of delivery,
            all necessary delivery documents concerning the trip in the service of
            CARRIER and all documents necessary for CARRIER to secure payment from
            the shipper and/or consignee, such as the bill of lading or freight
            bill, signed and dated confirming that the authorized consignee
            received the freight without notation of exception.
          </span>
        </h3>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={20}>
        <h3
          style={{
            paddingLeft: "23pt",
            textIndent: "35pt",
            textAlign: "justify"
          }}
        >
          <u>Term and Termination</u>.{" "}
          <span className="p">
            (a) This Contract shall become effective when signed by CONTRACTOR and
            a duly authorized representative of CARRIER, shall continue in effect
            until December 31st of the year in which the Contract is signed (the
            “Initial Term”), and shall automatically renew on January 1 of each
            year following the Initial Term for an additional year, unless
            terminated earlier as set forth herein, or if either party gives
            advance written notice to the other party of that party’s decision not
            to renew the Contract at least sixty (60) days prior to the end of the
            then current term, in which event the Contract will terminate at the
            end of the then current term. During the Initial Term or any renewal
            term the Contract may be terminated as follows:
          </span>
        </h3>
        <ol id="l12">
          <li data-list-text="i.">
            <p
              style={{
                paddingTop: "11pt",
                paddingLeft: "75pt",
                textIndent: "-40pt",
                textAlign: "justify"
              }}
            >
              Either party may terminate this Contract with or without cause by
              giving the other party not less than sixty (60) days written notice
              prior to the date of such termination.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="ii.">
            <p
              style={{
                paddingLeft: "75pt",
                textIndent: "-43pt",
                textAlign: "justify"
              }}
            >
              upon the occurrence of an Event of Default (defined below), CARRIER
              may, in its sole and absolute discretion, terminate this contract
              immediately without notice, which notice is hereby expressly waived
              by CONTRACTOR.
            </p>
          </li>
        </ol>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <ol id="l13">
          <li data-list-text="(b)">
            <p
              style={{
                paddingLeft: "94pt",
                textIndent: "-35pt",
                textAlign: "left"
              }}
            >
              An Event of Default is the occurrence of the following:
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
            <ol id="l14">
              <li data-list-text="i.">
                <p
                  className="s11"
                  style={{
                    paddingLeft: "75pt",
                    textIndent: "-41pt",
                    textAlign: "justify"
                  }}
                >
                  Immediate Event of Default.{" "}
                  <span className="p">
                    CONTRACTOR’s failure to comply with the following shall
                    constitute an immediate event of default, and CARRIER, with or
                    without notice to CONTRACTOR, who expressly waives any right
                    to such notice, may terminate this Contract in its discretion:
                  </span>
                </p>
                <ol id="l15">
                  <li data-list-text="(A)">
                    <p
                      style={{
                        paddingTop: "11pt",
                        paddingLeft: "75pt",
                        textIndent: "-22pt",
                        textAlign: "left"
                      }}
                    >
                      Failure to timely pay all or any portion of the amounts
                      payable to CARRIER under this Contract when due and payable;
                    </p>
                  </li>
                  <li data-list-text="(B)">
                    <p
                      style={{
                        paddingTop: "4pt",
                        paddingLeft: "75pt",
                        textIndent: "-22pt",
                        textAlign: "justify"
                      }}
                    >
                      Removal, sale, transfer, assignment, encumbrance, or
                      otherwise disposal or parting with possession of any cargo
                      or any portion thereof, or attempt to do any of the
                      foregoing, without CARRIER’S written consent;
                    </p>
                  </li>
                  <li data-list-text="(C)">
                    <p
                      style={{
                        paddingTop: "11pt",
                        paddingLeft: "75pt",
                        textIndent: "-22pt",
                        textAlign: "justify"
                      }}
                    >
                      Seizure of or levy upon any cargo by reason of any legal or
                      governmental process directed against CONTRACTOR;
                    </p>
                    <p style={{ textIndent: "0pt", textAlign: "left" }}>
                      <br />
                    </p>
                  </li>
                  <li data-list-text="(D)">
                    <p
                      style={{
                        paddingLeft: "75pt",
                        textIndent: "-22pt",
                        textAlign: "justify"
                      }}
                    >
                      CONTRACTOR’S failing generally to pay its debts or financial
                      obligations as they become due, or a petition in bankruptcy,
                      insolvency or reorganization is filed by or against
                      CONTRACTOR, or CONTRACTOR makes an assignment for the
                      benefit of creditors or CONTRACTOR consents to or acquiesces
                      in the appointment of a receiver, liquidator or trustee of
                      CONTRACTOR or its business or of the whole or any part of
                      CONTRACTOR’S assets;
                    </p>
                  </li>
                  <li data-list-text="(E)">
                    <p
                      style={{
                        paddingTop: "11pt",
                        paddingLeft: "75pt",
                        textIndent: "-22pt",
                        textAlign: "justify"
                      }}
                    >
                      CONTRACTOR taking unlawful possession of any cargo or
                      intentionally causing damage to any cargo;
                    </p>
                    <p style={{ textIndent: "0pt", textAlign: "left" }}>
                      <br />
                    </p>
                  </li>
                  <li data-list-text="(F)">
                    <p
                      style={{
                        paddingLeft: "75pt",
                        textIndent: "-22pt",
                        textAlign: "justify"
                      }}
                    >
                      CONTRACTOR’S material violation of any applicable laws,
                      rules, regulations and/or ordinances,;
                    </p>
                  </li>
                  <li data-list-text="(G)">
                    <p
                      style={{
                        paddingTop: "11pt",
                        paddingLeft: "75pt",
                        textIndent: "-22pt",
                        textAlign: "left"
                      }}
                    >
                      Hauling freight for a carrier other than an approved
                      carrier;
                    </p>
                    <p style={{ textIndent: "0pt", textAlign: "left" }}>
                      <br />
                    </p>
                  </li>
                  <li data-list-text="(H)">
                    <p
                      style={{
                        paddingLeft: "75pt",
                        textIndent: "-22pt",
                        textAlign: "justify"
                      }}
                    >
                      Termination of, or any default that with either notice or
                      the passage of time could give rise to a termination of, any
                      applicable purchase or lease agreement related to the
                      Equipment used or reasonably necessary to be able to perform
                      hereunder;
                    </p>
                  </li>
                  <li data-list-text="(I)">
                    <p
                      style={{
                        paddingTop: "11pt",
                        paddingLeft: "75pt",
                        textIndent: "-22pt",
                        textAlign: "justify"
                      }}
                    >
                      CARRIER’S determination in its reasonable discretion that
                      CONTRACTOR or its Workers are unfit to haul under CARRIER’S
                      authority or CONTRACTOR is otherwise unable to perform
                      hereunder; and
                    </p>
                  </li>
                  <li data-list-text="(J)">
                    <p
                      style={{
                        paddingTop: "11pt",
                        paddingLeft: "75pt",
                        textIndent: "-22pt",
                        textAlign: "left"
                      }}
                    >
                      CONTRACTOR’S (or its principal’s) death.
                    </p>
                    <p style={{ textIndent: "0pt", textAlign: "left" }}>
                      <br />
                    </p>
                  </li>
                </ol>
              </li>
              <li data-list-text="ii.">
                <p
                  className="s11"
                  style={{
                    paddingLeft: "75pt",
                    textIndent: "-43pt",
                    textAlign: "justify"
                  }}
                >
                  Events of Default Subject to Notice and Cure.{" "}
                  <span className="p">
                    In the event of (A) a breach of the terms of this Contract by
                    either party other than as set forth in Section 20(b)(i)
                    above, (B) breaching of any representation or warranty
                    hereunder (or furnishing any documents or information in
                    connection therewith, which proved to be incorrect in any
                    material respect at the time made), or (C) the non-material
                    violation of any applicable laws, rules, regulations and/or
                    ordinances, the non-breaching party may provide written notice
                    of such material breach and the breaching party shall have ten
                    (10) days from the provision of such notice to cure the
                    material breach (the “Cure Period”). If the breaching party
                    fails to cure the material breach by the end of the Cure
                    Period, such failure shall constitute an Event of Default.
                  </span>
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
              </li>
            </ol>
          </li>
          <li data-list-text="(c)">
            <p
              style={{
                paddingLeft: "23pt",
                textIndent: "53pt",
                textAlign: "justify"
              }}
            >
              CONTRACTOR shall provide CARRIER immediate notice of any Event of
              Default, or breach or default that with the passage of time or
              notice would constitute an Event of Default that is known or should
              have reasonably been known.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(d)">
            <p
              style={{
                paddingLeft: "23pt",
                textIndent: "53pt",
                textAlign: "justify"
              }}
            >
              Termination of this Contract by either party shall be effective on
              the prescribed date whether or not CONTRACTOR has, to the extent
              necessary, then removed from the Equipment all signs, placards,
              licenses and permits relating to operation under this Contract.
              Termination of this Contract by CONTRACTOR shall not serve to or be
              construed to void, modify or otherwise relieve CONTRACTOR from any
              obligations prescribed in any other contract or agreement between
              CONTRACTOR and CARRIER. Upon the termination of the Contract,
              CONTRACTOR’S authority to haul under CARRIER’S authority shall be
              revoked (except to the extent that a load being hauled under
              CARRIER’S authority and in compliance with this Contract may be in
              transit, and in such case, such revocation shall be effective at the
              earlier of
            </p>
          </li>
        </ol>
        <p
          style={{
            paddingTop: "4pt",
            paddingLeft: "23pt",
            textIndent: "0pt",
            textAlign: "justify"
          }}
        >
          delivery of the load or the passage of a reasonable amount of time to
          accomplish such delivery). CONTRACTOR shall immediately return to
          CARRIER all bills of lading, manifests, cab cards, license plates,
          mobilecom equipment, fuel cards, transponders and other equipment,
          papers and forms provided by CARRIER to CONTRACTOR for CONTRACTOR’s use
          during the term of this Contract. Additionally, upon termination of the
          Contract, any amounts owed to CONTRACTOR but not yet paid by CARRIER
          shall be deposited into CONTRACTOR’s Escrow Fund pending a final
          accounting as described in Paragraph 14.E. Any property not returned to
          CARRIER may result in a deduction from CONTRACTOR’s Escrow Fund.
        </p>
      </li>
      <li data-list-text={21}>
        <h3
          style={{
            paddingTop: "11pt",
            paddingLeft: "23pt",
            textIndent: "35pt",
            textAlign: "justify"
          }}
        >
          <u>Confidentiality and Non-Solicitation</u>.{" "}
          <span className="p">
            (a) CONTRACTOR hereby recognizes and acknowledges that the identity of
            CARRIER's customers, as they may exist now or in the future, is a
            valuable, special, and unique asset of the business of CARRIER and
            constitutes a trade secret and confidential proprietary information of
            CARRIER. CONTRACTOR agrees, during and after the term of this Contract
            and thereafter, not to disclose the identity of CARRIER's customers or
            any part thereof to any person, firm, corporation, association, or
            other entity for any reason or purpose whatsoever without CARRIER's
            prior written consent. CONTRACTOR agrees to preserve as "Confidential
            Matters" the identities of CARRIER’s customers all trade secrets,
            know- how, and information relating to CARRIER's business, forms,
            customers, vendors, contractors, drivers, processes, developments,
            sales and promotional systems, prices, and operations, which
            information may be obtained from tariffs, contracts, freight bills,
            letters, reports, disclosures, reproductions, books, records, other
            contractors, or other sources of any kind resulting from or related to
            this Contact. CONTRACTOR agrees to regard and treat such Confidential
            Matters as the sole property of CARRIER and shall not publish,
            disclose, or disseminate the same to others without the prior written
            consent of CARRIER.
          </span>
        </h3>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <ol id="l16">
          <li data-list-text="(b)">
            <p
              style={{
                paddingLeft: "23pt",
                textIndent: "71pt",
                textAlign: "justify"
              }}
            >
              <u>
                CONTRACTOR recognizes the substantial expenditure of time and
                effort which
              </u>{" "}
              <u>
                CARRIER devotes to the recruitment, hiring, orientation, training
                and retention of its commercial drivers.
              </u>{" "}
              <u>
                Accordingly, CONTRACTOR agrees that, for a period beginning on the
                Effective Date of and ending twelve
              </u>
            </p>
            <p
              style={{
                paddingLeft: "23pt",
                textIndent: "0pt",
                textAlign: "justify"
              }}
            >
              <u>
                (12)&nbsp; months&nbsp; after&nbsp; termination&nbsp; of&nbsp;
                this&nbsp; Contract,&nbsp; regardless&nbsp; of&nbsp; the&nbsp;
                reason&nbsp; for&nbsp; such&nbsp; termination,
              </u>{" "}
              <u>
                CONTRACTOR shall not use any Confidential Matters, directly or
                indirectly, for himself or on behalf of any
              </u>{" "}
              <u>
                other person or entity, solicit, offer employment to, hire,
                encourage to resign employment, or otherwise
              </u>{" "}
              <u>retain the services of any employee CARRIER.</u>
            </p>
          </li>
          <li data-list-text="(c)">
            <p
              style={{
                paddingTop: "11pt",
                paddingLeft: "23pt",
                textIndent: "71pt",
                textAlign: "justify"
              }}
            >
              <u>
                CONTRACTOR further recognizes the substantial expenditure of time
                and effort
              </u>{" "}
              <u>
                which CARRIER devotes to developing its relationships with and
                procuring business from its customers.
              </u>{" "}
              <u>
                CONTRACTOR agrees that, for a period beginning on the Effective
                Date and ending twelve (12) months
              </u>{" "}
              <u>
                after termination of this Contract, CONTRACTOR will not provide
                transportation services to any customer
              </u>{" "}
              <u>
                of CARRIER for whom CONTRACTOR provided transportation services
                during the term of this Contract.
              </u>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="(d)">
            <p
              style={{
                paddingLeft: "23pt",
                textIndent: "71pt",
                textAlign: "justify"
              }}
            >
              In the event of any breach or threatened breach by CONTRACTOR of the
              provisions of this paragraph, CARRIER shall be entitled to an
              injunction, without necessity of posting bond, restraining
              CONTRACTOR from disclosing, in whole or in part, CARRIER's customers
              and/or any other Confidential Matters. Nothing hereunder shall be
              construed as prohibiting CARRIER from pursuing any remedies
              available to CARRIER at law or in equity for such breach or
              threatened breach of this paragraph, including the recovery of
              monetary damages from CONTRACTOR and all expenses and attorney’s
              fees. CONTRACTOR’s obligations under this Paragraph 21 shall survive
              termination of this Contract.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text={22}>
        <h3
          style={{
            paddingLeft: "23pt",
            textIndent: "35pt",
            textAlign: "justify"
          }}
        >
          <u>Applicable Law, Jurisdiction, And Jury Waiver</u>.{" "}
          <span className="p">
            (a) This Contract and all provisions herein shall be governed by and
            interpreted in accordance with the laws of the State of Tennessee and
            in the event of any disagreement or litigation, the laws of Tennessee
            shall apply without regard to conflict-of- laws principles. The
            parties agree that any and all claims between the parties shall be
            brought exclusively in the courts of proper jurisdiction located in
            Davidson County, Tennessee. For purposes of this paragraph, the term
            “claim” or “claims” shall mean and include any and all legal or
            factual disputes, claims, allegations, causes of action, demands,
            administrative proceedings or controversies arising, or having arisen,
            that in any way relate to or arise from this Contract, CONTRACTOR’s
            business relationship with CARRIER and/or the termination of this
            Contract or that business relationship, which could be brought in
            court, including, but not limited to, any and all claims under any
            federal, state, municipal and/or local minimum wage, overtime pay
            and/or wage payment laws, any federal, state, municipal and/or local
            law, rule, statute, ordinance or
          </span>
        </h3>
        <p
          style={{
            paddingTop: "4pt",
            paddingLeft: "23pt",
            textIndent: "0pt",
            textAlign: "justify"
          }}
        >
          regulation, any claims based on any law, rule, statute, ordinance,
          regulation, public policy, contract, tort, or common law,
          misclassification claims or claims related to employment or independent
          contractor status, claims under the Truth-in-Leasing Regulations, 49 CFR
          §376.1 et. seq., claims of fraud or misrepresentation, both negligent
          and intentional; claims of procedural and substantive unconscionability,
          claims of unjust enrichment, claims of forced labor or involuntary
          servitude, claims of breach of contract and/or any claim for costs, fees
          and other expenses or relief, including attorneys’ fees.{" "}
          <b>
            However, the parties specifically agree that claims for injunctive
            relief and/or specific performance may be brought in the federal court
            having jurisdiction over Davidson County, Tennessee or if the federal
            court does not have jurisdiction, the state courts situated in
            Davidson County, Tennessee, or the proper jurisdiction wherever
            located.
          </b>
        </p>
        <ol id="l17">
          <li data-list-text="(b)">
            <h3
              style={{
                paddingTop: "11pt",
                paddingLeft: "23pt",
                textIndent: "71pt",
                textAlign: "justify"
              }}
            >
              CONTRACTOR AGREES TO WAIVE ALL RIGHTS TO BRING, OR BE A PARTY TO,
              ANY PRE-EXISTING OR FUTURE CLASS, COLLECTIVE OR CONSOLIDATED ACTION,
              AND/OR CLASS, COLLECTIVE OR CONSOLIDATED CLAIM(S), AGAINST CARRIER
              AND AGREES TO PURSUE ANY PRE-EXISTING OR FUTURE CLAIM(S) ON AN
              INDIVIDUAL BASIS ONLY AND UNDER THE TERMS OF THIS AGREEMENT.
            </h3>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
            <h3
              style={{
                paddingLeft: "23pt",
                textIndent: "0pt",
                textAlign: "justify"
              }}
            >
              BY SIGNING BELOW CONTRACTOR IS GIVING UP CONTRACTOR’S RIGHTS TO
              INITIATE OR PARTICIPATE IN CLASS, COLLECTIVE OR CONSOLIDATED ACTIONS
              AGAINST CARRIER.
            </h3>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
            <h3
              style={{
                paddingLeft: "23pt",
                textIndent: "0pt",
                textAlign: "justify"
              }}
            >
              IF THIS PARAGRAPH IS DETERMINED TO BE UNENFORCEABLE, ANY CLAIMS, AS
              DEFINED ABOVE, BETWEEN CONTRACTOR AND CARRIER SHALL BE SUBJECT TO A
              NON-JURY TRIAL IN THE FEDERAL COURT HAVING JURISDICTION OVER
              DAVIDSON COUNTY, TENNESSEE OR IF THE FEDERAL COURT DOES NOT HAVE
              JURISDICTION, THE STATE COURTS SITUATED IN DAVIDSON COUNTY,
              TENNESSEE. BY SIGNING BELOW, CONTRACTOR AND CARRIER EACH EXPRESSLY
              WAIVE ANY RIGHT TO A JURY TRIAL FOR ANY AND ALL SUCH CLAIMS.
            </h3>
          </li>
          <li data-list-text="(c)">
            <p
              style={{
                paddingTop: "11pt",
                paddingLeft: "23pt",
                textIndent: "71pt",
                textAlign: "justify"
              }}
            >
              In the event that any provision of this paragraph shall be construed
              as unlawful or unenforceable, and if the offending provision can be
              deleted without affecting the primary intention of the parties or
              can be reformed to achieve the primary intention of the parties as
              expressed herein, then the offending provision shall be so deleted
              or reformed and the remainder of this Contract shall remain in full
              force and effect as written.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text={23}>
        <h3
          style={{
            paddingLeft: "23pt",
            textIndent: "35pt",
            textAlign: "justify"
          }}
        >
          <u>CONTRACTOR’s Indemnification Obligations</u>.{" "}
          <span className="p">
            Except as otherwise provided in this Contract, except for losses or
            damages resulting from CARRIER’s negligence, and notwithstanding
            whether or not any Operational Audit was conducted by CARRIER,
            CONTRACTOR agrees, as part of the consideration for this Contract, to
            defend, hold harmless and indemnify CARRIER and its affiliates,
            successors and assigns and their respective owners, shareholders,
            officers, directors, partners, members, managers, agents and
            employees, from, for and against any and all losses, damages, claims,
            demands and liabilities of every nature and kind, including attorneys’
            fees and costs, arising from or in connection with CONTRACTOR and/or
            CONTRACTOR’S Workers or representatives, possession, use, operation or
            storage of the Equipment, or the performance of services under this
            Contract. CONTRACTOR further agrees that operation of the Equipment
            beyond the scope and authority of this Contract will constitute
            operation solely of CONTRACTOR; and CONTRACTOR agrees to defend, hold
            harmless and indemnify CARRIER regarding all claims and actions,
            including attorney fees and costs, which arise from such unauthorized
            actions and operations of CONTRACTOR. The foregoing obligations of
            CONTRACTOR in this paragraph shall survive the termination of this
            Contract, until the expiration of any time period established by law
            for bringing claims, demands or legal proceedings with respect to
            which indemnification may be claimed under this paragraph. It is
            specifically agreed that all insurance coverages of CONTRACTOR
            required under this Contract, shall be available, and may be used by
            CARRIER, to satisfy CONTRACTOR’s indemnity obligations to CARRIER
            under this paragraph and as provided elsewhere in the Contract.
          </span>
        </h3>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={24}>
        <h3
          style={{
            paddingLeft: "23pt",
            textIndent: "35pt",
            textAlign: "justify"
          }}
        >
          <u>Notices</u>.{" "}
          <span className="p">
            (a) Any notice, demand, or approval (“notice”) required or permitted
            to be given or obtained hereunder shall be in writing, and shall be
            sufficiently given or made if (i) delivered in person
          </span>
        </h3>
        <p
          style={{
            paddingTop: "4pt",
            paddingLeft: "23pt",
            textIndent: "0pt",
            textAlign: "justify"
          }}
        >
          during normal business hours on a business day, (ii) sent by prepaid
          first class registered mail, or (iii) sent by any electronic means of
          sending messages, including facsimile transmission, in-cab message
          transmission (e.g. via the Platform Science, Omnitracs or Qualcomm
          systems), communications via any mobile or smartphone application, and
          electronic mail (each an “Electronic Transmission”), during normal
          business hours on a business day, and addressed as follows:
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <ol id="l18">
          <li data-list-text="A.">
            <p
              style={{
                paddingLeft: "55pt",
                textIndent: "-35pt",
                textAlign: "left"
              }}
            >
              To CARRIER at:
            </p>
            <p
              style={{
                paddingTop: "11pt",
                paddingLeft: "35pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              7135 Centennial Place
            </p>
            <p
              style={{
                paddingLeft: "35pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              Nashville, TN 37209
            </p>
            <p
              style={{
                paddingLeft: "35pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              Attn:{" "}
              <u>
                Eric Morrison
              </u>{" "}
              Telephone No.:{" "}
              <u>
                615-846-6110
              </u>
              Facsimile No.:{" "}
              <u>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
              </u>{" "}
              E-mail Address:{" "}
              <u>
                emorrison@westernexp.com
              </u>
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="B.">
            <p
              style={{
                paddingLeft: "55pt",
                textIndent: "-35pt",
                textAlign: "left"
              }}
            >
              To CONTRACTOR at:
            </p>
          </li>
        </ol>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <p
          style={{
            paddingLeft: "239pt",
            textIndent: "0pt",
            lineHeight: "1pt",
            textAlign: "left"
          }}
        >
          <span />
        </p>
        <p
          style={{
            paddingLeft: "239pt",
            textIndent: "0pt",
            lineHeight: "1pt",
            textAlign: "left"
          }}
        >
          <span />
        </p>
        <p
          style={{
            paddingLeft: "239pt",
            textIndent: "0pt",
            lineHeight: "1pt",
            textAlign: "left"
          }}
        >
          <span />
        </p>
        <p
        style={{
          paddingTop: "11pt",
          paddingLeft: "30pt",
          textIndent: "0pt",
          textAlign: "left"
        }}
      >
        Attention:{" "}
        <u>
        { props.viewObject !== undefined ? props.viewObject.OwnerName1 : props.ownerData.name}
        </u>
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "30pt", textIndent: "0pt", textAlign: "left" }}>
        Telephone No.:{" "}
        <u>
        { props.viewObject !== undefined ? props.viewObject.OwnerPhone : props.ownerData!.areaCode.toString() + props.ownerData!.phoneNumber.toString()}
        </u>
      </p>
      <p
        style={{
          paddingTop: "11pt",
          paddingLeft: "30pt",
          textIndent: "0pt",
          textAlign: "left"
        }}
      >
        Facsimile No.:{" "}
        <u>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </u>
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
      <p style={{ paddingLeft: "30pt", textIndent: "0pt", textAlign: "left" }}>
        E-mail Address:{" "}
        <u>
        { props.viewObject !== undefined ? props.viewObject.OwnerEmail : props.ownerData.email}
        </u>
      </p>
      <p style={{ textIndent: "0pt", textAlign: "left" }}>
        <br />
      </p>
        <p
          style={{
            paddingLeft: "23pt",
            textIndent: "71pt",
            textAlign: "justify"
          }}
        >
          (b) Each notice sent in accordance with this paragraph shall be deemed
          to have been received at the time and on the day it was delivered at
          such address, at the beginning of business on the third business day
          after it was mailed (excluding each business day during which there
          existed any general interruption of postal services due to strike,
          lockout, or other cause), or one hour after they were sent on the same
          day that it was sent by Electronic Transmission, or at the start of
          business on the first business day thereafter if the day on which it was
          sent by Electronic Transmission was not a business day. Either party may
          change its address for notice by giving notice to the other party as
          provided in this paragraph.
        </p>
      </li>
      <li data-list-text={25}>
        <h3
          style={{
            paddingTop: "11pt",
            paddingLeft: "23pt",
            textIndent: "35pt",
            textAlign: "justify"
          }}
        >
          <u>Fuel Purchase</u>.{" "}
          <span className="p">
            CONTRACTOR is not required to use an EFS card to purchase fuel.
            CONTRACTOR may however take advantage of CARRIER’s fuel network and
            receive a discount off the retail price of fuel. If CONTRACTOR uses an
            EFS card, purchases fuel with that card, and the price paid by
            CONTACTOR is higher than the amount negotiated between CARRIER and the
            fuel retailer, the remaining balance is earned and credited to
            CARRIER. CONTRACTOR will not receive the benefit of any additional
            discounts or rebates CARRIER may negotiate and receive from the fuel
            retailer. CONTRACTOR understands and agrees that if additional rebates
            and/or discounts are supplied by the fuel retailer, they will be
            considered earnings of CARRIER and will not be credited back to
            CONTRACTOR. As an independent contractor, CONTRACTOR may purchase fuel
            in whatever manner, quantity, or payment method deemed to be the best
            for CONTRACTOR’S individual business. If EFS card services are not
            used, CONTRACTOR must submit fuel receipts through Transflo or such
            other designated solution for fuel tax reporting and accounting.
          </span>
        </h3>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={26}>
        <h3
          style={{
            paddingLeft: "23pt",
            textIndent: "35pt",
            textAlign: "justify"
          }}
        >
          Training Services.{" "}
          <span className="p">
            CARRIER and CONTRACTOR may mutually agree to enter into a Training
            Services Agreement in the Form of Appendix 5 attached hereto and
            CONTRACTOR hereby acknowledges that the services provided under any
            such agreement are within the scope of CONTRACTOR’s contractual
            obligations hereunder, including but not limited to CARRIER’s
            assignment of
          </span>
        </h3>
        <p
          style={{
            paddingTop: "4pt",
            paddingLeft: "23pt",
            textIndent: "0pt",
            textAlign: "left"
          }}
        >
          trainee drivers to CONTRACTOR. For clarity, CARRIER’s trainee shall be
          considered CONTRACTOR’S Worker except as otherwise provided herein.
        </p>
      </li>
      <li data-list-text={27}>
        <h3
          style={{
            paddingTop: "11pt",
            paddingLeft: "23pt",
            textIndent: "35pt",
            textAlign: "justify"
          }}
        >
          <u>Assignment</u>.{" "}
          <span className="p">
            Neither this Contract nor any rights or obligations hereunder shall be
            assignable by CONTRACTOR without the prior written consent of CARRIER.
            CARRIER may assign this Contract to any person or entity, without
            notice or consent of CONTRACTOR.
          </span>
        </h3>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={28}>
        <p
          style={{
            paddingLeft: "23pt",
            textIndent: "35pt",
            textAlign: "justify"
          }}
        >
          <u>
            <b>Force Majeure</b>
          </u>
          . In the event that a party is prevented, delayed, or interrupted in
          performing its obligations under this Contract due to any occurrence
          beyond its control, such as, but not limited to, strikes, walk outs,
          acts of terrorism, diseases, viruses, pandemics, epidemics or acts of
          governments or government agencies or other authorities, then such
          prevention, delay, or interruption shall not be construed to be a breach
          or default under this Contract. The party so prevented, delayed, or
          interrupted shall give notice to the other party of such events as soon
          as is reasonably possible and the parties shall use their reasonable
          best efforts to comply with the terms of this Contract notwithstanding
          such prevention, delay, or interruption. Provided however that any
          excuse of performance under this paragraph shall not excuse, affect, or
          diminish any obligations under any other agreements with other entities
          or third parties, including but not limited to, equipment costs,
          payments, or other financial obligations under such agreements.
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={29}>
        <h3
          style={{
            paddingLeft: "23pt",
            textIndent: "35pt",
            textAlign: "justify"
          }}
        >
          <u>No Wavier</u>.{" "}
          <span className="p">
            Any waiver of, or consent to depart from, the requirements of any
            provision of this Contract shall be effective only if it is in writing
            and signed by the party giving it, and only in the specific instance
            and for the specific purpose for which it has been given. No failure
            on the part of either party to exercise, and no delay in exercising,
            any right under this Contract shall operate as a waiver of such right.
            No single or partial exercise of any such right shall preclude any
            other or further exercise of such right or the exercise of any other
            right.
          </span>
        </h3>
      </li>
      <li data-list-text={30}>
        <h3
          style={{
            paddingTop: "11pt",
            paddingLeft: "23pt",
            textIndent: "35pt",
            textAlign: "justify"
          }}
        >
          <u>Final Agreement</u>.{" "}
          <span className="p">
            This Contract, including the Appendices and attachments hereto,
            constitutes the entire contract and agreement between the parties
            pertaining to the subject matter hereof, and supersedes and replaces
            all prior formal and informal agreements, contracts, proposals,
            promises, inducements, representations, conditions, warranties,
            understandings, negotiations, and discussions, whether oral or
            written, of or between the parties. No change, modification, waiver,
            or amendment of this Contract shall be binding unless executed in
            writing or authenticated by the party against whom enforcement is
            sought.
          </span>
        </h3>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={31}>
        <h3
          style={{
            paddingLeft: "23pt",
            textIndent: "35pt",
            textAlign: "justify"
          }}
        >
          <u>Severability</u>.{" "}
          <span className="p">
            If any provision contained in this Contract is found by a court of
            competent jurisdiction to be invalid, illegal, or unenforceable in any
            respect, the validity, legality, or enforceability of the remaining
            provisions shall not be in any way affected or impaired thereby.
          </span>
        </h3>
      </li>
      <li data-list-text={32}>
        <h3
          style={{
            paddingTop: "11pt",
            paddingLeft: "23pt",
            textIndent: "35pt",
            textAlign: "justify"
          }}
        >
          <u>Counterparts Execution</u>.{" "}
          <span className="p">
            This Contract may be executed by the parties in separate counterparts
            (whether by facsimile transmission, electronic or otherwise) each of
            which, when so executed and delivered, shall be deemed to constitute
            an original, but all of which together shall constitute one and the
            same contract and agreement.
          </span>
        </h3>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={33}>
        <h3
          style={{
            paddingLeft: "23pt",
            textIndent: "35pt",
            textAlign: "justify"
          }}
        >
          <u>CONTRACTOR Acknowledgement</u>.{" "}
          <span className="p">
            CONTRACTOR acknowledges and agrees that CONTRACTOR has had sufficient
            time to carefully review the contents of this Contract, has had an
            opportunity, if desired, to review the contents of the Contract with
            counsel of CONTRACTOR’s choosing, and CONTRACTOR understands and
            agrees with the contents hereof and CONTRACTOR has signed this
            Contract as CONTRACTOR’s free act and deed.
          </span>
        </h3>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={34}>
        <h3
          style={{
            paddingLeft: "23pt",
            textIndent: "35pt",
            textAlign: "justify"
          }}
        >
          <u>Headings</u>.{" "}
          <span className="p">
            The headings used in this Contract have no substantive effect and are
            used for convenience only.
          </span>
        </h3>
      </li>
    </ol>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p
      className="s12"
      style={{ paddingLeft: "11pt", textIndent: "0pt", textAlign: "center" }}
    >
      [Signature Page Follows]
    </p>
    <p
      className="s12"
      style={{
        paddingTop: "4pt",
        paddingLeft: "23pt",
        textIndent: "0pt",
        textAlign: "justify"
      }}
    >
      THIS CONTRACT CONTAINS BINDING PROVISIONS REGARDING (i) CLASS, COLLECTIVE
      AND CONSOLIDATED ACTION WAIVER AND (ii) JURY TRIAL WAIVER, THAT MAY BE
      ENFORCED BY THE PARTIES.
    </p>
    <p
    style={{
      paddingTop: "11pt",
      paddingLeft: "23pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    Western Express, Inc. 7135 Centennial Place
  </p> 
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <span />
  </p>
  <p style={{ paddingLeft: "23pt", textIndent: "0pt", textAlign: "left" }}>
    Nashville, TN 37209
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p
    style={{
      paddingLeft: "239pt",
      textIndent: "0pt",
      lineHeight: "1pt",
      textAlign: "left"
    }}
  >
    <span />
  </p>
  <p
    className="s13"
    style={{
      paddingLeft: "23pt",
      textIndent: "0pt",
      lineHeight: "132%",
      textAlign: "left"
    }}
  >
    <span>
      {" "}
      <span>
    <span className="p">By: Eric Morrison</span>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
        {" "}
        <span className="s14">Title:</span>
        <span className="s15">
          <u>VP of Lease Purchase</u>
        </span>
        <span className="s16"></span>
      </span>
    </span>
  </p>

  <p
    className="s13"
    style={{
      paddingLeft: "23pt",
      textIndent: "0pt",
      lineHeight: "132%",
      textAlign: "left"
    }}
  >
    <span>
    <h3
        style={{
          paddingTop: "4pt",
          lineHeight: "199%",
          textAlign: "left"
        }}
      >
        CONTRACTOR
      </h3>
      <span>
      {props.viewObject !== undefined ? <img src={props.signatureData} alt="Signature"/> : <div>________________________________</div>}
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
        {" "}
        <span className="s15">
          <u>Independent Contractor</u>
        </span>
        <span className="s16"></span>
      </span>
    </span>
  </p>
  <h3
    style={{
      paddingTop: "4pt",
      paddingLeft: "30pt",
      textIndent: "35pt",
      lineHeight: "199%",
      textAlign: "left"
    }}
  >
      APPENDIX 1 <u>EQUIPMENT DESCRIPTION</u>
    </h3>
    <p style={{ paddingLeft: "10pt", textIndent: "0pt", textAlign: "center" }}>
    UNIT#{" "}
    <u>
    { props.viewObject !== undefined ? props.viewObject.UnitNumber1 : userInfo!.unit}
    </u>
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p style={{ paddingLeft: "23pt", textIndent: "0pt", textAlign: "justify" }}>
    This is to certify that the following described Equipment:
  </p>
  <p style={{ paddingTop: "11pt", textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p style={{ paddingLeft: "23pt", textIndent: "0pt", textAlign: "left" }}>
    TRACTOR:
    <u>{ props.viewObject !== undefined ? props.viewObject.UnitNumber1 : userInfo!.unit}</u>
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p style={{ paddingLeft: "23pt", textIndent: "0pt", textAlign: "left" }}>
    MAKE:
    <u>{  props.viewObject !== undefined ? props.viewObject.Make1 : props.unitData.unit.UNMAKE.trim()}</u>
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p style={{ paddingLeft: "23pt", textIndent: "0pt", textAlign: "left" }}>
    YEAR:
    <u>{ props.viewObject !== undefined ? props.viewObject.UnitYear1 : props.unitData.unit.UNYEAR}</u>
  </p>
  <p
    style={{
      paddingTop: "11pt",
      paddingLeft: "23pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    MODEL:
    <u>{ props.viewObject !== undefined ? props.viewObject.Model1 : props.unitData!.unit.UNMAKE.trim() === 'FRHT' ? "Cascadia" : "Prostar"}</u>
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p style={{ paddingLeft: "23pt", textIndent: "0pt", textAlign: "left" }}>
    VIN#:
    <u>{ props.viewObject !== undefined ? props.viewObject.VIN1 : props.unitData!.unit.UNSER}</u>
  </p>
  <p style={{ paddingTop: "11pt", textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
    <p style={{ paddingLeft: "23pt", textIndent: "0pt", textAlign: "justify" }}>
      is owned or leased by CONTRACTOR and is being operated in the service of
      CARRIER under the Contract until said Contract shall be terminated.
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p style={{ paddingLeft: "23pt", textIndent: "0pt", textAlign: "justify" }}>
      This Equipment Description shall be valid and in force so long as it is in
      the possession of CONTRACTOR and the Contract remains in effect, until
      notice of termination of the Contract has been given to CONTRACTOR in
      writing as provided in the Contract.
    </p>
    <p
      style={{
        paddingTop: "11pt",
        paddingLeft: "23pt",
        textIndent: "0pt",
        textAlign: "justify"
      }}
    >
      The original version of the Contract is kept at the office of CARRIER. Dated
      this <u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u> day of
    </p>
    <p style={{ paddingLeft: "23pt", textIndent: "0pt", textAlign: "justify" }}>
      <u>
        {" "}
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
      </u>
      , 20<u> &nbsp;&nbsp; </u>.
    </p>
    <p style={{ paddingTop: "11pt", textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p style={{ paddingLeft: "23pt", textIndent: "0pt", textAlign: "left" }}>
      CARRIER: CONTRACTOR:
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <span />
    </p>
    <p style={{ paddingLeft: "23pt", textIndent: "0pt", textAlign: "left" }}>
      Western Express, Inc.
    </p>
    <p style={{ paddingTop: "10pt", textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p
      className="s17"
      style={{
        paddingLeft: "23pt",
        textIndent: "0pt",
        lineHeight: "1pt",
        textAlign: "left"
      }}
    >
      <span>
        {" "}
        <span />
      </span>
    </p>
    <h3
      style={{
        paddingTop: "4pt",
        paddingLeft: "11pt",
        textIndent: "0pt",
        textAlign: "center"
      }}
    >
      APPENDIX 2
    </h3>
    <p
      className="s8"
      style={{
        paddingTop: "11pt",
        paddingLeft: "11pt",
        textIndent: "0pt",
        textAlign: "center"
      }}
    >
      RECEIPT FOR EQUIPMENT BY CARRIER
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p style={{ paddingLeft: "23pt", textIndent: "35pt", textAlign: "left" }}>
    Western Express, Inc., CARRIER, hereby acknowledges receipt of the Equipment
    described below from CONTRACTOR at{" "}
    <u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u>
    am/pm on this <u>{props.viewObject !== undefined ? props.viewObject.date1 : props.date} </u>
    day of
    , 20<u>{props.viewObject !== undefined ? props.viewObject.Year3 : props.year}</u>, in
  </p>
  <p style={{ paddingLeft: "23pt", textIndent: "0pt", textAlign: "left" }}>
    <u>{props.viewObject !== undefined ? props.viewObject.OwnerCity : props.ownerData!.city}</u>
    (City),
    <u>{props.viewObject !== undefined ? props.viewObject.OwnerState : props.ownerData!.state}</u>
    (State), and under the terms of the Contract between the parties of this
    same date.
  </p>
    <p style={{ paddingTop: "11pt", textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>

  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p style={{ paddingLeft: "23pt", textIndent: "0pt", textAlign: "justify" }}>
    This is to certify that the following described Equipment:
  </p>
  <p style={{ paddingTop: "11pt", textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p style={{ paddingLeft: "23pt", textIndent: "0pt", textAlign: "left" }}>
    TRACTOR:
    <u>{ props.viewObject !== undefined ? props.viewObject.UnitNumber1 : userInfo!.unit}</u>
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p style={{ paddingLeft: "23pt", textIndent: "0pt", textAlign: "left" }}>
    MAKE:
    <u>{  props.viewObject !== undefined ? props.viewObject.Make1 : props.unitData.unit.UNMAKE.trim()}</u>
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p style={{ paddingLeft: "23pt", textIndent: "0pt", textAlign: "left" }}>
    YEAR:
    <u>{ props.viewObject !== undefined ? props.viewObject.UnitYear1 : props.unitData.unit.UNYEAR}</u>
  </p>
  <p
    style={{
      paddingTop: "11pt",
      paddingLeft: "23pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    MODEL:
    <u>{ props.viewObject !== undefined ? props.viewObject.Model1 : props.unitData!.unit.UNMAKE.trim() === 'FRHT' ? "Cascadia" : "Prostar"}</u>
  </p>
  <p style={{ textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p style={{ paddingLeft: "23pt", textIndent: "0pt", textAlign: "left" }}>
    VIN#:
    <u>{ props.viewObject !== undefined ? props.viewObject.VIN1 : props.unitData!.unit.UNSER}</u>
  </p>
  <p style={{ paddingTop: "11pt", textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
    <p
      style={{
        paddingLeft: "23pt",
        textIndent: "0pt",
        lineHeight: "1pt",
        textAlign: "left"
      }}
    >
      <span />
    </p>
    <p style={{ paddingLeft: "23pt", textIndent: "0pt", textAlign: "left" }}>
      CARRIER
    </p>
    <h4
      style={{
        paddingTop: "3pt",
        paddingLeft: "45 pt",
        textIndent: "71pt",
        lineHeight: "200%",
        textAlign: "left"
      }}
    >
      APPENDIX 3 <u>CONTRACTOR’S COMPENSATION (Flatbed)</u>
    </h4>
    <p
      className="s19"
      style={{ paddingLeft: "23pt", textIndent: "35pt", textAlign: "left" }}
    >
      In accordance with Paragraph 2 of the Contract, CARRIER and CONTRACTOR agree
      CONTRACTOR shall be paid based on the point to point rates
      <span className="s20">2</span> below calculated by Rand McNally{" "}
      <i>
        <b>TM </b>
      </i>
      Inc. Milemaker
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p
      className="s19"
      style={{ paddingLeft: "1pt", textIndent: "0pt", textAlign: "center" }}
    >
      0-200 Miles $2.00 per mile
    </p>
    <p
      className="s19"
      style={{ paddingLeft: "1pt", textIndent: "0pt", textAlign: "center" }}
    >
      201-400 Miles $1.75 per mile
    </p>
    <p
      className="s19"
      style={{ paddingLeft: "1pt", textIndent: "0pt", textAlign: "center" }}
    >
      401+ Miles $1.50 per mile
    </p>
    <h4
      style={{
        paddingTop: "10pt",
        paddingLeft: "23pt",
        textIndent: "0pt",
        textAlign: "justify"
      }}
    >
      For the avoidance of doubt and as an example, if the laden dispatched miles
      are between 0 and 200 miles for that particular load, CONTRACTOR will be
      paid $2.00 per mile for each loaded mile driven on that route. As another
      example, if the laden dispatched miles are more than 200 and less than 401
      miles for that particular load, CONTRACTOR will be paid $1.75 per mile for
      each mile driven on that route.
    </h4>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p
      className="s19"
      style={{ paddingLeft: "23pt", textIndent: "0pt", textAlign: "justify" }}
    >
      Assessorial charges shall be paid as follows:
    </p>
    <ol id="l19">
      <li data-list-text={1}>
        <p
          className="s19"
          style={{
            paddingTop: "10pt",
            paddingLeft: "40pt",
            textIndent: "-17pt",
            textAlign: "left"
          }}
        >
          Stop Offs: As paid by shipper/customer up to $500 per trip
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={2}>
        <p
          className="s19"
          style={{ paddingLeft: "40pt", textIndent: "-17pt", textAlign: "left" }}
        >
          Detention: As paid by shipper/customer up to $500 per trip
        </p>
      </li>
      <li data-list-text={3}>
        <p
          className="s19"
          style={{
            paddingTop: "10pt",
            paddingLeft: "45pt",
            textIndent: "-21pt",
            textAlign: "justify"
          }}
        >
          Tarping: $40.00 (flatbed only). In order to receive Tarp Pay, CONTRACTOR
          must submit photographs of the tarped load through the onboard mobile
          device, cellular phone, or mobile application. If CONTRACTOR fails to
          submit photographs of the tarped load, no tarp pay will be issued to
          contractor.
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={4}>
        <p
          className="s19"
          style={{
            paddingLeft: "40pt",
            textIndent: "-17pt",
            textAlign: "justify"
          }}
        >
          Fuel Surcharge: The Department of Energy (“DOE”) Average, as published
          each Monday, minus $1.30, divided by 7, rounded to the nearest 10
          <span className="s20">th</span> of a cent. This fuel surcharge is paid
          regardless of the fuel surcharge paid to CARRIER by its customer. Fuel
          surcharge is paid only on loaded miles.
        </p>
        <p style={{ paddingTop: "10pt", textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <p
          className="s19"
          style={{ paddingLeft: "23pt", textIndent: "0pt", textAlign: "justify" }}
        >
          No other assessorial charges will be paid to CONTRACTOR.
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <h4
          style={{ paddingLeft: "23pt", textIndent: "0pt", textAlign: "justify" }}
        >
          For example, if the DOE price for on road diesel is $3.559, then the
          surcharge for the next seven days will be as follows:
        </h4>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <h4
          style={{ paddingLeft: "14pt", textIndent: "0pt", textAlign: "center" }}
        >
          $3.559 - $1.30 = 2.259 ÷ 7= .3227 rounded to 32.3 cents per mile on
          LADEN MILES ONLY
        </h4>
        <h4
          style={{
            paddingTop: "10pt",
            paddingLeft: "23pt",
            textIndent: "0pt",
            textAlign: "justify"
          }}
        >
          As another example, if the DOE price for on road diesel is $4.559, then
          the surcharge for the next seven days will be as follows:
        </h4>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <h4
          style={{ paddingLeft: "11pt", textIndent: "0pt", textAlign: "center" }}
        >
          $4.559 – $1.30 = 3.259 ÷ 7 = .4655 rounded to 46.6 cents per mile on
          LADEN MILES ONLY
        </h4>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <p
          className="s19"
          style={{ paddingLeft: "23pt", textIndent: "0pt", textAlign: "justify" }}
        >
          CONTRACTOR will be paid for any additional services on a case-by-case
          basis as negotiated between CONTRACTOR and CARRIER and the amount and/or
          calculation for such payment shall be specified in a separate written
          addendum which will be provided to CONTRACTOR prior to the commencement
          of any trip for which such payment will be made.
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <p
          style={{
            paddingLeft: "23pt",
            textIndent: "0pt",
            lineHeight: "1pt",
            textAlign: "left"
          }}
        >
          <span />
        </p>
        <p
          className="s22"
          style={{
            paddingTop: "4pt",
            paddingLeft: "23pt",
            textIndent: "0pt",
            textAlign: "left"
          }}
        >
          2<span className="s4"> </span>
          <span className="p">
            Point to point mileage rates are only paid on dispatched laden miles.
            Point to point rates will not apply to empty miles.
          </span>
        </p>
        <h3
          style={{
            paddingTop: "3pt",
            paddingLeft: "11pt",
            textIndent: "0pt",
            textAlign: "center"
          }}
        >
          APPENDIX 4
        </h3>
        <p
          className="s8"
          style={{
            paddingTop: "11pt",
            paddingLeft: "11pt",
            textIndent: "0pt",
            textAlign: "center"
          }}
        >
          AUTHORIZED DEDUCTIONS AND FUEL DISCOUNTS
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <p
          style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
        >
          CONTRACTOR and CARRIER agree that the below is a non-exhaustive,
          non-exclusive list of potential deductions CONTRACTOR has authorized
          CARRIER to make from his or her settlements and/or Escrow Fund. Where
          the cost of the item is a known, fixed amount, it is specified. It is
          understood and agreed that the cost of certain items can be variable
          depending upon circumstances and cannot, before the fact, be stated
          herein with complete accuracy or certainty. Where required, CARRIER will
          provide CONTRACTOR with a written explanation and itemization of any
          deductions made from CONTRACTOR’s settlements and/or Escrow Fund, an
          itemization of how the amount of each item deducted was computed and
          copies of any documents which are necessary to determine the validity of
          the charge. Other items may be deducted from CONTRACTOR’s settlements
          and/or Escrow Fund as authorized in the Contract or by CONTRACTOR,
          whether orally or in writing.
        </p>
        <p
          style={{
            paddingTop: "11pt",
            paddingLeft: "5pt",
            textIndent: "0pt",
            textAlign: "justify"
          }}
        >
          CONTRACTOR authorizes CARRIER to deduct from settlements to CONTRACTOR
          and/or from the Escrow Fund established by CONTRACTOR under the
          Contract, the following items:
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <ol id="l20">
          <li data-list-text="A.">
            <p
              style={{
                paddingLeft: "50pt",
                textIndent: "-36pt",
                textAlign: "left"
              }}
            >
              Any advance or loans of any kind made by CARRIER to CONTRACTOR or
              CONTRACTOR’s Workers.
            </p>
          </li>
          <li data-list-text="B.">
            <p
              style={{
                paddingTop: "11pt",
                paddingLeft: "50pt",
                textIndent: "-36pt",
                textAlign: "left"
              }}
            >
              Any amount due CARRIER by CONTRACTOR by reason of CONTRACTOR'S
              failure to make proper collection on C.O.D. or collect shipments.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="C.">
            <p
              style={{
                paddingLeft: "50pt",
                textIndent: "-36pt",
                textAlign: "left"
              }}
            >
              Amounts for Minimum Limit of Liability for Combined Single Limit
              Nontrucking Auto Liability coverage of $1,000,000, per the Contract.
            </p>
          </li>
          <li data-list-text="D.">
            <p
              style={{
                paddingTop: "11pt",
                paddingLeft: "50pt",
                textIndent: "-35pt",
                textAlign: "left"
              }}
            >
              Payments for the deductible for any loss or damage to third persons
              as provided for in the Contract.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="E.">
            <p
              style={{
                paddingLeft: "50pt",
                textIndent: "-35pt",
                textAlign: "left"
              }}
            >
              Payments for the deductible for any loss or damage to property as
              provided for in the Contract.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="F.">
            <p
              style={{
                paddingLeft: "50pt",
                textIndent: "-35pt",
                textAlign: "left"
              }}
            >
              Payments for damage to or loss of cargo as provided for in the
              Contract.
            </p>
          </li>
          <li data-list-text="G.">
            <p
              style={{
                paddingTop: "11pt",
                paddingLeft: "50pt",
                textIndent: "-36pt",
                textAlign: "left"
              }}
            >
              Payment for losses or costs incurred by CARRIER as a result of loss
              of or damage to its Equipment or other equipment as provided in the
              Contract.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="H.">
            <p
              style={{
                paddingLeft: "50pt",
                textIndent: "-36pt",
                textAlign: "left"
              }}
            >
              Lease payment or purchase payments to any third party related to the
              lease or purchase of the Equipment.
            </p>
          </li>
          <li data-list-text="I.">
            <p
              style={{
                paddingTop: "11pt",
                paddingLeft: "50pt",
                textIndent: "-36pt",
                textAlign: "justify"
              }}
            >
              Any other amounts which CONTRACTOR authorizes CARRIER to deduct from
              CONTRACTOR’s settlements and/or Escrow Fund in a written contract
              with a third party.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="J.">
            <p
              style={{
                paddingLeft: "50pt",
                textIndent: "-36pt",
                textAlign: "justify"
              }}
            >
              Unless CONTRACTOR provides the items listed below, CARRIER may
              initially pay for and later charge back to CONTRACTOR and deduct
              from CONTRACTOR’s settlement(s), and/or Escrow Fund, amounts for any
              or all of the following: license registration fees, mud flaps,
              flags, fuses, reflectors, lights, light bulbs, citations, repairs,
              cash advances, cargo claims, accident claims, mileage and/or fuel
              taxes, insurance, tires, telephone, towing charges, and any repairs
              to CONTRACTOR’s Equipment.
            </p>
          </li>
          <li data-list-text="K.">
            <p
              style={{
                paddingTop: "11pt",
                paddingLeft: "50pt",
                textIndent: "-36pt",
                textAlign: "left"
              }}
            >
              Apportioned tags at $32.00 per week. This amount is intended to
              approximate the cost of this item in a manner to provide even and
              predictable payments for CONTRACTOR.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="L.">
            <p
              style={{
                paddingLeft: "50pt",
                textIndent: "-36pt",
                textAlign: "left"
              }}
            >
              Fuel Tax (IFTA) at $37.00 per week. This amount is intended to
              approximate the cost of this item in a manner to provide even and
              predictable payments for CONTRACTOR.
            </p>
          </li>
          <li data-list-text="M.">
            <p
              style={{
                paddingTop: "11pt",
                paddingLeft: "50pt",
                textIndent: "-36pt",
                textAlign: "left"
              }}
            >
              Federal Highway Tax (HVUT) at $11.00 per week. This amount is
              intended to approximate the cost of this item in a manner to provide
              even and predictable payments for CONTRACTOR.
            </p>
          </li>
          <li data-list-text="N.">
            <p
              style={{
                paddingTop: "3pt",
                paddingLeft: "50pt",
                textIndent: "-36pt",
                textAlign: "justify"
              }}
            >
              To the extent that CONTRACTOR utilizes Platform Science, Onmitracs
              or Qualcomm equipment facilitated by CARRIER, an Equipment Rental
              Fee at $15.00 per week. This amount is intended to approximate the
              cost of this item in a manner to provide even and predictable
              payments for CONTRACTOR.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
          <li data-list-text="O.">
            <p
              style={{
                paddingLeft: "50pt",
                textIndent: "-35pt",
                textAlign: "justify"
              }}
            >
              FLATBED OPERATIONS ONLY: Load Securement Equipment Fee at
              $0.02/MILE, not to exceed
            </p>
            <p
              style={{
                paddingLeft: "50pt",
                textIndent: "0pt",
                textAlign: "justify"
              }}
            >
              $2,000.00 per calendar year. This fee shall apply only to miles
              driven by CONTRACTOR for flatbed transportation.
            </p>
          </li>
          <li data-list-text="P.">
            <p
              style={{
                paddingTop: "11pt",
                paddingLeft: "50pt",
                textIndent: "-36pt",
                textAlign: "justify"
              }}
            >
              CARRIER shall deduct advances and fuel purchases made by CONTRACTOR
              utilizing CARRIER’s EFS card. Any fuel purchases made by CONTRACTOR
              with additional discounts beyond those specified to CONTRACTOR, will
              revert back and be paid to CARRIER. Fuel discounts which are
              available to CONTRACTOR under the Contract as of the effective date
              of the Contract include the following:
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
            <p
              style={{
                paddingLeft: "55pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              Pilot $0.10 per gallon
            </p>
            <p
              style={{
                paddingLeft: "55pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              Flying J $0.10 per gallon
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
            <p
              style={{
                paddingLeft: "50pt",
                textIndent: "0pt",
                textAlign: "justify"
              }}
            >
              CONTRACTOR will not receive the benefit of any additional discounts
              or rebates CARRIER may negotiate and receive in excess of the above.
              CONTRACTOR understands and agrees that if additional rebates and/or
              discounts are supplied by the fuel retailer, they will be considered
              earnings of the CARRIER and will not be credited back or paid to
              CONTRACTOR.
            </p>
          </li>
          <li data-list-text="Q.">
            <p
              style={{
                paddingTop: "11pt",
                paddingLeft: "50pt",
                textIndent: "-36pt",
                textAlign: "justify"
              }}
            >
              When CONTRACTOR is in service for CARRIER, CONTRACTOR shall maintain
              insurance acceptable to CARRIER at CONTRACTOR’s cost and expense as
              specified in the Contract. CONTRACTOR may elect to purchase required
              insurance independently or through CARRIER. If CONTRACTOR elects to
              purchase insurance through CARRIER, CONTRACTOR authorizes CARRIER to
              charge back to CONTRACTOR’s settlements and/or Escrow Fund, the
              premiums, service fees and costs of such insurance.
            </p>
          </li>
          <li data-list-text="R.">
            <p
              style={{
                paddingLeft: "50pt",
                textIndent: "-35pt",
                textAlign: "justify"
              }}
            >
              Liability Insurance Premiums as described below:
            </p>
          </li>
        </ol>
      </li>
    </ol>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p
      style={{
        paddingTop: "6pt",
        paddingLeft: "50pt",
        textIndent: "0pt",
        textAlign: "left"
      }}
    >
      Insurance Premium Weekly Deductions (effective
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <table
      style={{ borderCollapse: "collapse", marginLeft: "43.52pt" }}
      cellSpacing={0}
    >
      <tbody>
        <tr style={{ height: "18pt" }}>
          <td style={{ width: "147pt" }}>
            <p
              className="s23"
              style={{
                paddingLeft: "2pt",
                textIndent: "0pt",
                lineHeight: "11pt",
                textAlign: "left"
              }}
            >
              Occupational/Accident:
            </p>
          </td>
          <td style={{ width: "41pt" }}>
            <p
              className="s24"
              style={{
                paddingRight: "4pt",
                textIndent: "0pt",
                lineHeight: "12pt",
                textAlign: "center"
              }}
            >
              $ <u>27.46</u>
            </p>
          </td>
        </tr>
        <tr style={{ height: "34pt" }}>
          <td style={{ width: "147pt" }}>
            <p
              className="s23"
              style={{
                paddingTop: "5pt",
                paddingLeft: "2pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              Auto Liability
            </p>
            <p
              className="s23"
              style={{ paddingLeft: "2pt", textIndent: "0pt", textAlign: "left" }}
            >
              (includes Deductible Buy Back):
            </p>
          </td>
          <td style={{ width: "41pt" }}>
            <p
              style={{ paddingTop: "4pt", textIndent: "0pt", textAlign: "left" }}
            >
              <br />
            </p>
            <p
              className="s23"
              style={{
                paddingRight: "2pt",
                textIndent: "0pt",
                textAlign: "center"
              }}
            >
              $<u> 39.23</u>
            </p>
          </td>
        </tr>
        <tr style={{ height: "24pt" }}>
          <td style={{ width: "147pt" }}>
            <p
              className="s23"
              style={{
                paddingTop: "6pt",
                paddingLeft: "2pt",
                textIndent: "0pt",
                textAlign: "left"
              }}
            >
              Non Trucking:
            </p>
          </td>
          <td style={{ width: "41pt" }}>
            <p
              className="s23"
              style={{
                paddingTop: "5pt",
                paddingLeft: "1pt",
                paddingRight: "3pt",
                textIndent: "0pt",
                textAlign: "center"
              }}
            >
              $<u> 6.69&nbsp;&nbsp;</u>
            </p>
          </td>
        </tr>
        <tr style={{ height: "18pt" }}>
          <td style={{ width: "147pt" }}>
            <p
              className="s23"
              style={{
                paddingTop: "5pt",
                paddingLeft: "2pt",
                textIndent: "0pt",
                lineHeight: "11pt",
                textAlign: "left"
              }}
            >
              Physical Damage:
              $<u> {props.viewObject !== undefined ? props.viewObject.Premium : props.tierTable.PDPremiums}</u>
            </p>
          </td>
          <td style={{ width: "41pt" }}>
            <p
              className="s23"
              style={{
                paddingTop: "5pt",
                textIndent: "0pt",
                lineHeight: "11pt",
                textAlign: "center"
              }}
            >
              $<u> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</u>
            </p>
          </td>
        </tr>
      </tbody>
    </table>
    <p
      style={{
        paddingTop: "11pt",
        paddingLeft: "70pt",
        textIndent: "0pt",
        textAlign: "left"
      }}
    >
      Annual Rate per $100: $<u> 4.84%</u> Monthly Rate per $100: $_4<u>.84%</u>
    </p>
    <p
      style={{
        paddingTop: "4pt",
        paddingLeft: "17pt",
        textIndent: "0pt",
        textAlign: "left"
      }}
    >
      April 2024 <span className="s27">)</span>
    </p>
    <p style={{ textIndent: "0pt", lineHeight: "1pt", textAlign: "left" }}>
      <span />
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p style={{ paddingLeft: "50pt", textIndent: "0pt", textAlign: "left" }}>
      Passenger Insurance:{" "}
      <u>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </u>
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <span />
    </p>
    <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
      Acknowledged and Accepted:
    </p>
    <p style={{ paddingTop: "10pt", textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p
      style={{
        paddingLeft: "257pt",
        textIndent: "0pt",
        lineHeight: "1pt",
        textAlign: "left"
      }}
    >
      <span />
    </p>
    <p style={{ textIndent: "0pt", lineHeight: "11pt", textAlign: "left" }}>
      ________________________
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }} />
    <p style={{ paddingLeft: "20pt", textIndent: "0pt", textAlign: "left" }}>
    CARRIER:
  </p>
  <p style={{ paddingTop: "10pt", textIndent: "0pt", textAlign: "left" }}>
    <br />
  </p>
  <p style={{ paddingLeft: "20pt", textIndent: "0pt", textAlign: "left" }}>
    CONTRACTOR:
  </p>
  <p
    style={{
      paddingTop: "11pt",
      paddingLeft: "45pt",
      textIndent: "0pt",
      textAlign: "left"
    }}
  >
    {props.viewObject !== undefined ? <img src={props.signatureData} alt="Signature"/> : <div>________________________________</div>}
    <p style={{ paddingTop: "10pt", textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <u>{localStorage.getItem("username")}</u>
    <p style={{ paddingTop: "10pt", textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <u>{localStorage.getItem("driverCode")}</u>
    <p style={{ paddingTop: "10pt", textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>

  </p>
    <p
      className="s4"
      style={{ paddingTop: "4pt", textIndent: "0pt", textAlign: "right" }}
    >
      Watermarked Example
    </p>
    <p
      className="s8"
      style={{
        paddingTop: "5pt",
        paddingLeft: "11pt",
        textIndent: "0pt",
        textAlign: "center"
      }}
    >
      APPENDIX 5
    </p>
    <p
      className="s8"
      style={{
        paddingTop: "11pt",
        paddingLeft: "11pt",
        textIndent: "0pt",
        textAlign: "center"
      }}
    >
      TRAINING SERVICES AGREEMENT
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <span />
    </p>
    <p style={{ paddingLeft: "5pt", textIndent: "36pt", textAlign: "justify" }}>
      THIS TRAINING SERVICES AGREEMENT (“Training Agreement”) is made and
      effective this{" "}
      <span className="s7">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
      <span className="s4"> </span>day of{" "}
      <u>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
      </u>
      , <u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u>, between Western
      Express, Inc., a Tennessee corporation (“WESTERN”), having its principle
      offices at 7135 Centennial Place, Nashville, TN 37209 and{" "}
      <span className="s7">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
      </span>
      (“CONTRACTOR”), having its principle offices or mailing address at{" "}
      <u>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
      </u>
      .
    </p>
    <p
      style={{
        paddingTop: "11pt",
        paddingLeft: "5pt",
        textIndent: "36pt",
        textAlign: "justify"
      }}
    >
      WHEREAS, WESTERN EXPRESS, INC. (“WESTERN”), is an Interstate For Hire
      Common/Contract Motor Carrier for whom CONTRACTOR is providing freight
      services under the terms of a separate Independent Contractor Operating
      Agreement (“Hauling Agreement”); and
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p
      style={{
        paddingLeft: "41pt",
        textIndent: "0pt",
        lineHeight: "23pt",
        textAlign: "left"
      }}
    >
      WHEREAS, WESTERN has need for trainers that exceeds its capacity of employee
      driver trainers; and WHEREAS, CONTRACTOR has the requisite experience, and
      desires to use his/her skills, knowledge, and
    </p>
    <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
      experience to provide driver training services to WESTERN, which training
      provides benefits CONTRACTOR as an additional revenue stream for
      CONTRACTOR’s business;
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p style={{ paddingLeft: "5pt", textIndent: "36pt", textAlign: "justify" }}>
      NOW, THEREFORE, in consideration of the mutual covenants and agreements
      contained herein, the parties mutually agree as follows:
    </p>
    <ol id="l21">
      <li data-list-text={1}>
        <h3
          style={{
            paddingTop: "11pt",
            paddingLeft: "41pt",
            textIndent: "-36pt",
            textAlign: "justify"
          }}
        >
          <u>SCOPE OF SERVICES.</u>{" "}
          <span className="p">
            (a) CONTRACTOR shall provide general transportation and commercial
            driver training services (the “Training Services”) to new and
            less-experienced drivers selected and assigned to CONTRACTOR by
            WESTERN (hereinafter referred to as “Driver Trainees”). All Driver
            Trainees assigned to CONTRACTOR by WESTERN will meet the Federal Motor
            Carrier Safety Regulation requirements for qualified drivers, but each
            Driver Trainee may have limited driving experience at the time
            assigned. This Training Agreement contemplates Training Services
            covering general industry transportation and hauling activities and is
            not intended to provide training specific or exclusive to any motor
            carrier, shipper, receiver, customer or any other entity. The Training
            Services provided by CONTRACTOR should cover various topics and
            skills, such as familiarity with the federal motor carrier safety
            regulations, hours of service regulations, pre- and post-trip
            inspections, backing and turning activities, trailer operations, load
            securement, signage, and toll and weigh station practices. The
            specific training curriculum and materials and skills assessments
            shall be chosen by CONTRACTOR.
          </span>
        </h3>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <ol id="l22">
          <li data-list-text="(b)">
            <p
              style={{
                paddingLeft: "41pt",
                textIndent: "35pt",
                textAlign: "justify"
              }}
            >
              Upon completion of training, the Driver Trainee assigned to
              CONTRACTOR must be able to successfully complete any evaluations or
              assessments administered by WESTERN and be qualified to provide
              transportation services to WESTERN as a solo driver, in WESTERN’s
              sole discretion, in compliance with all applicable regulations.
            </p>
          </li>
          <li data-list-text="(c)">
            <p
              style={{
                paddingTop: "11pt",
                paddingLeft: "41pt",
                textIndent: "35pt",
                textAlign: "justify"
              }}
            >
              Without limiting the foregoing, and as a condition to allowing
              WESTERN’S employee to board any Equipment, CONTRACTOR shall verify
              that its drivers are appropriately evaluated as appropriate for
              having Driver Trainees in the Equipment, and shall complete, and
              cause its approved Workers (as defined in the Hauling Agreement) to
              complete, appropriate training in respect of sexual harassment,
              safety, compliance, and any other areas that reasonably relate to
              training a new or inexperienced driver. CONTRACTOR acknowledges and
              agrees that WESTERN may facilitate such training on the foregoing
              subjects and any others reasonably determined by WESTERN as a result
              of placing its Driver Trainees with CONTRACTOR.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text={2}>
        <h3
          style={{
            paddingLeft: "41pt",
            textIndent: "-36pt",
            textAlign: "justify"
          }}
        >
          <u>CONTRACTOR COMPENSATION.</u>{" "}
          <span className="p">
            In exchange for the provision of Training Services, CONTRACTOR shall
            be paid in accordance with Appendix 3 of the Contractor Hauling
            Agreement for all miles driven while providing Training Services,
            inclusive of all miles driven by any Driver Trainee. CONTRACTOR
            acknowledges that these additional miles are of substantial value to
            CONTRACTOR’s operations and that these miles represent adequate
            consideration for the Training Services provided by CONTRACTOR.
          </span>
        </h3>
        <p
          className="s4"
          style={{ paddingTop: "4pt", textIndent: "0pt", textAlign: "right" }}
        >
          Watermarked Example
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <span />
        </p>
        <p
          style={{
            paddingTop: "11pt",
            paddingLeft: "41pt",
            textIndent: "0pt",
            textAlign: "justify"
          }}
        >
          WESTERN shall pay or reimburse to CONTRACTOR any direct expenses and
          costs incurred during the training period related to WESTERN’s
          employment of any Driver Trainee. These costs and expenses include items
          such as hotel charges, bus, airline, taxi, or other transportation
          charges, and all wages due to Driver Trainee. However, WESTERN shall not
          pay or reimburse any such expenses or costs that are incurred solely for
          CONTRACTOR’s convenience or preference or incurred due to CONTRACTOR’s
          failure to follow instructions regarding transfer, relocation, or
          disposition of any Driver Trainee.
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={3}>
        <h3
          style={{
            paddingLeft: "41pt",
            textIndent: "-36pt",
            textAlign: "justify"
          }}
        >
          <u>CONTRACTOR EXPENSES.</u>{" "}
          <span className="p">
            Except for the costs contained in Paragraph 2 above, WESTERN shall
            have no responsibility for any additional costs or expenses associated
            with the provision of services under this Training Agreement.
            CONTRACTOR shall be solely responsible for all costs and expenses
            incurred as a result of providing the training services contemplated
            herein, including any applicable fees, costs, or expenses associated
            with increased or additional wear and tear, repairs, loss or damage
            claims, deductibles, fuel, mileage, including empty, bobtail, or
            deadhead mileage, or depreciation to the equipment operated by
            CONTRACTOR. Neither WESTERN nor the Driver Trainee assigned to
            CONRACTOR by WESTERN shall be responsible for any such costs,
            expenses, or fees of any kind.
          </span>
        </h3>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={4}>
        <h3
          style={{
            paddingLeft: "41pt",
            textIndent: "-36pt",
            textAlign: "justify"
          }}
        >
          <u>TERM &amp; TERMINATION.</u>{" "}
          <span className="p">
            This Training Agreement shall commence on the effective date and
            remain in effect until Termination (defined herein) by either party.
            Termination shall mean the occurrence of any one the following: (a)
            immediately upon the occurrence of termination of CONTRACTOR’s Hauling
            Agreement;
          </span>
        </h3>
        <ol id="l23">
          <li data-list-text="(b)">
            <p
              style={{
                paddingLeft: "41pt",
                textIndent: "0pt",
                textAlign: "justify"
              }}
            >
              immediately upon CONTRACTOR’s violation of any representation or
              warranty contained herein, or (c) the later of both (i) five (5)
              days’ advance written notice and (ii) return of the Driver Trainee
              to a location designated by WESTERN. Notice shall be deemed given as
              of (I) 7:30 AM prevailing central time on the third (3
              <span className="s28">rd</span>) day after transmitting written
              notice to the other via prepaid first class registered mail, or (II)
              the earlier of actual receipt or one hour after transmitting on the
              same day by any electronic means of sending messages, including
              facsimile transmission, in-cab message transmission (e.g. via the
              Platform Science, Omnitracs or Qualcomm systems), communications via
              any mobile or smartphone application, and electronic mail; and (d)
              immediately in the event that CONTRACTOR terminates the Hauling
              Agreement with WESTERN.
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text={5}>
        <p
          className="s8"
          style={{ paddingLeft: "40pt", textIndent: "-35pt", textAlign: "left" }}
        >
          REPRESENTATIONS AND WARRANTIES.
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
        <ol id="l24">
          <li data-list-text="A.">
            <p
              style={{
                paddingLeft: "50pt",
                textIndent: "-36pt",
                textAlign: "left"
              }}
            >
              <u>BY CONTRACTOR.</u> CONTRACTOR hereby represents, warrants, and
              acknowledges that such representations and warranties are material
              to WESTERN’s entry into this Training Agreement:
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
            <ol id="l25">
              <li data-list-text="I.">
                <p
                  style={{
                    paddingLeft: "50pt",
                    textIndent: "-35pt",
                    textAlign: "left"
                  }}
                >
                  CONTRACTOR possesses the requisite knowledge, skill, and
                  experience regarding:
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
                <ol id="l26">
                  <li data-list-text="a)">
                    <p
                      style={{
                        paddingLeft: "55pt",
                        textIndent: "-36pt",
                        textAlign: "left"
                      }}
                    >
                      The operation of the equipment being used during the
                      provision of the Training Services;
                    </p>
                    <p style={{ textIndent: "0pt", textAlign: "left" }}>
                      <br />
                    </p>
                  </li>
                  <li data-list-text="b)">
                    <p
                      style={{
                        paddingLeft: "55pt",
                        textIndent: "-36pt",
                        textAlign: "left"
                      }}
                    >
                      The services and operations for which WESTERN is engaging
                      CONTRACTOR’s provision of Training Services;
                    </p>
                    <p style={{ textIndent: "0pt", textAlign: "left" }}>
                      <br />
                    </p>
                  </li>
                  <li data-list-text="c)">
                    <p
                      style={{
                        paddingLeft: "55pt",
                        textIndent: "-36pt",
                        textAlign: "left"
                      }}
                    >
                      The applicable laws, regulations, and ordinances (including
                      without limitation the Federal Motor Carrier Safety
                      Regulations);
                    </p>
                    <p style={{ textIndent: "0pt", textAlign: "left" }}>
                      <br />
                    </p>
                    <ol id="l27">
                      <li data-list-text="I.">
                        <p
                          style={{
                            paddingLeft: "70pt",
                            textIndent: "-41pt",
                            textAlign: "justify"
                          }}
                        >
                          Prior to providing the Training Services, CONTRACTOR has
                          been in compliance with all applicable laws,
                          regulations, and ordinances, except as may be disclosed
                          in writing to WESTERN prior to execution of this
                          Training Agreement.
                        </p>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                          <br />
                        </p>
                      </li>
                      <li data-list-text="II.">
                        <p
                          style={{
                            paddingLeft: "70pt",
                            textIndent: "-44pt",
                            textAlign: "justify"
                          }}
                        >
                          During the course of providing the Training Services,
                          CONTRACTOR will remain in compliance with all applicable
                          laws, regulations, and ordinances.
                        </p>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                          <br />
                        </p>
                      </li>
                      <li data-list-text="III.">
                        <p
                          style={{
                            paddingLeft: "70pt",
                            textIndent: "-47pt",
                            textAlign: "left"
                          }}
                        >
                          CONTRACTOR has completed any training or additional
                          education required by WESTERN as part of its training
                          program.
                        </p>
                      </li>
                    </ol>
                    <p
                      className="s4"
                      style={{
                        paddingTop: "4pt",
                        textIndent: "0pt",
                        textAlign: "right"
                      }}
                    >
                      Watermarked Example
                    </p>
                    <p
                      style={{
                        paddingTop: "5pt",
                        textIndent: "0pt",
                        textAlign: "left"
                      }}
                    >
                      <br />
                    </p>
                  </li>
                </ol>
              </li>
            </ol>
          </li>
          <li data-list-text="B.">
            <p
              style={{
                paddingLeft: "50pt",
                textIndent: "-36pt",
                textAlign: "justify"
              }}
            >
              <u>BY&nbsp; WESTERN.</u> WESTERN hereby represents, warrants, and
              acknowledges that such representations and warranties are material
              to CONTRACTOR’s entry into this Training Agreement:
            </p>
            <p style={{ textIndent: "0pt", textAlign: "left" }}>
              <br />
            </p>
            <ol id="l28">
              <li data-list-text="I.">
                <p
                  style={{
                    paddingLeft: "70pt",
                    textIndent: "-36pt",
                    textAlign: "left"
                  }}
                >
                  All Driver Trainees assigned to CONTRACTOR shall meet the
                  Federal Motor Carrier Safety Regulations regarding commercial
                  driver qualifications.
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <br />
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                  <span />
                </p>
              </li>
              <li data-list-text="II.">
                <p
                  style={{
                    paddingLeft: "70pt",
                    textIndent: "-36pt",
                    textAlign: "left"
                  }}
                >
                  Any and all remaining or additional representations and
                  warranties are specifically disclaimed by WESTERN.
                </p>
              </li>
            </ol>
          </li>
        </ol>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={6}>
        <h3
          style={{
            paddingLeft: "41pt",
            textIndent: "-36pt",
            textAlign: "justify"
          }}
        >
          <u>INDEMNITY</u>.{" "}
          <span className="p">
            To the fullest extent provided by law, CONTRACTOR shall defend, hold
            harmless, indemnify and reimburse each of WESTERN and Provider, and of
            each of the foregoing (collectively, the “Indemnified Parties”) from,
            for and against all losses, expenses, liabilities, damages, claims,
            lawsuits, actions at law or equity, administrative or governmental
            actions or legal actions (including attorneys’ fees and costs), and
            including but not limited claims and actions, by CONTRACTOR or any of
            CONTRACTOR’s employees, agents, servants, contractors, subcontractors,
            helpers or representatives, a carrier, the Carrier, Driver Trainees,
            or any third party, arising out of the provision of the training
            services contemplated herein or the provision of services under the
            Hauling Agreement. Without limitation to any of the foregoing
            indemnity obligations, CONTRACTOR specifically acknowledges the risks
            and liabilities associated with allowing Driver Trainees to operate
            the equipment used in the provision of Training Services and
            CONTRACTOR assumes all risk and liability arising from the provision
            of the Training Services and releases the Indemnified Parties from any
            such risk and/or liability. This paragraph shall survive the
            termination of this Agreement.
          </span>
        </h3>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={7}>
        <h3
          style={{
            paddingLeft: "41pt",
            textIndent: "-36pt",
            textAlign: "justify"
          }}
        >
          <u>APPLICABLE LAW &amp; JURISDICTION</u>.{" "}
          <span className="p">
            This Training Agreement and all provisions herein shall be governed by
            and interpreted in accordance with the laws of the State of Tennessee
            and in the event of any disagreement or litigation, the laws of
            Tennessee shall apply without regard to conflict-of-laws principles.
            The parties agree that any and all claims between the parties shall be
            brought exclusively in the courts of proper jurisdiction located in
            Davidson County, Tennessee. However, the parties specifically agree
            that claims for injunctive relief and/or specific performance may be
            brought in the federal court having jurisdiction over Davidson County,
            Tennessee or if the federal court does not have jurisdiction, the
            state courts situated in Davidson County, Tennessee, or the proper
            jurisdiction where ever located.
          </span>
        </h3>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={8}>
        <p
          style={{
            paddingLeft: "41pt",
            textIndent: "-36pt",
            textAlign: "justify"
          }}
        >
          <u>
            <b>ATTORNEYS’ FEES AND COSTS</b>
          </u>
          . In the event a suit, claim or action is commenced or filed to enforce
          this Training Agreement or with respect to this Training Agreement, the
          prevailing party shall be reimbursed by the other party for all costs
          and expenses incurred in connection with the suit, claim or action,
          including, without limitation, reasonable attorneys’ fees at hearing or
          trial and on appeal.
        </p>
        <p style={{ textIndent: "0pt", textAlign: "left" }}>
          <br />
        </p>
      </li>
      <li data-list-text={9}>
        <p
          style={{
            paddingLeft: "41pt",
            textIndent: "-36pt",
            textAlign: "justify"
          }}
        >
          <u>
            <b>ENTIRE AGREEMENT</b>
          </u>
          . This Agreement and the attached Schedule A, incorporated herein,
          contain the entire and final contract and agreement of the parties and
          shall not be qualified or supplemented by course of dealing. None of the
          provisions of this Agreement may be modified, amended, or waived except
          in a writing signed or authenticated by the party against whom
          enforcement is sought.
        </p>
      </li>
    </ol>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <h3 style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
      Western Express, Inc. CONTRACTOR: 7135 Centennial Place
    </h3>
    <h3 style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
      Nashville, TN 37209
    </h3>
    <p style={{ paddingTop: "11pt", textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
      By:{" "}
      <u>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </u>
    </p>
    <p style={{ textIndent: "0pt", textAlign: "left" }}>
      <br />
    </p>
    <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
      Title:{" "}
      <u>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </u>
    </p>
    <p
      style={{
        paddingLeft: "257pt",
        textIndent: "0pt",
        lineHeight: "1pt",
        textAlign: "left"
      }}
    >
      <span />
    </p>
  </div>
  

}
export default HaulingAgreementFlatbed;
